
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1c76"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1c76"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bOBEI", function(module, exports) {
$parcel$export(module.exports, "WidgetLoadingState", function () { return (parcelRequire("77EIr")).WidgetLoadingState; });
parcelRequire("77EIr");

});
parcelRegister("77EIr", function(module, exports) {

$parcel$export(module.exports, "WidgetLoadingState", function () { return $32a5af37108dc44b$export$7e27a2e8e18ffe9b; });

var $6uMv9 = parcelRequire("6uMv9");

var $akcQ4 = parcelRequire("akcQ4");

var $3YfCm = parcelRequire("3YfCm");
const $32a5af37108dc44b$var$Header = (0, $akcQ4.default).div`
    width: 30%;
    height: 30px;
    border-radius: 8px;
`;
const $32a5af37108dc44b$var$Content = (0, $akcQ4.default).div`
    height: ${({ height: height })=>height ?? "100px"};
    border-radius: 8px;
`;
const $32a5af37108dc44b$var$Button = (0, $akcQ4.default).div`
    width: 130px;
    height: 40px;
    border-radius: 16px;
    &.sm {
        height: 30px;
    }
`;
const $32a5af37108dc44b$export$7e27a2e8e18ffe9b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).memo(function WidgetLoadingState({ title: title, headerButton: headerButton, height: height }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $3YfCm.WidgetLayout), {
        "data-testid": "widgetLoadingState",
        title: title ? title : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($32a5af37108dc44b$var$Header, {
            className: "shimmer-container"
        }),
        actionButtons: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($32a5af37108dc44b$var$Button, {
            className: "shimmer-container"
        }),
        ...headerButton && {
            headerButtons: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($32a5af37108dc44b$var$Button, {
                className: "shimmer-container sm"
            })
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($32a5af37108dc44b$var$Content, {
        className: "shimmer-container",
        height: height
    }));
});

});


parcelRegister("acee3", function(module, exports) {
$parcel$export(module.exports, "filterFieldsBySearchValue", function () { return (parcelRequire("6IEar")).filterFieldsBySearchValue; });
parcelRequire("6IEar");

});
parcelRegister("6IEar", function(module, exports) {

$parcel$export(module.exports, "filterFieldsBySearchValue", function () { return $67a79de605884d43$export$de29389d53f8108f; });
function $67a79de605884d43$export$de29389d53f8108f(fields, search) {
    if (!search) return true;
    return !!fields.filter((field)=>{
        if (!field) return false;
        return field.toLocaleLowerCase().includes(search.trim().toLocaleLowerCase());
    }).length;
}

});


parcelRegister("9J2qy", function(module, exports) {
$parcel$export(module.exports, "MeasurementDeviceSearchListForm", function () { return (parcelRequire("fZJUc")).MeasurementDeviceSearchListForm; });
parcelRequire("fZJUc");

});
parcelRegister("fZJUc", function(module, exports) {

$parcel$export(module.exports, "MeasurementDeviceSearchListForm", function () { return $b3baf6f179c7f7a3$export$2e95fb6f6a74a034; });

var $6uMv9 = parcelRequire("6uMv9");

var $cbVaW = parcelRequire("cbVaW");

var $8LupL = parcelRequire("8LupL");

var $1xw2Y = parcelRequire("1xw2Y");

var $4MH4b = parcelRequire("4MH4b");

var $aL1Vp = parcelRequire("aL1Vp");

var $aol72 = parcelRequire("aol72");
const $b3baf6f179c7f7a3$export$2e95fb6f6a74a034 = /*#__PURE__*/ (0, $6uMv9.memo)(function MeasurementDeviceSearchListForm({ clearDevice: clearDevice, onSubmit: onSubmit, loading: loading, style: style }) {
    const text = (0, $aL1Vp.default)();
    const { register: register, handleSubmit: handleSubmit, reset: reset, control: control } = (0, $cbVaW.useForm)();
    const statuses = [
        {
            value: "",
            label: text("lblAnyStatusOption")
        },
        {
            value: text("lblOffline"),
            label: text("lblOffline")
        },
        {
            value: text("lblOnline"),
            label: text("lblOnline")
        }
    ];
    const measurementDevicesProducts = [
        {
            value: "",
            label: text("lblAnyProductOption")
        },
        {
            value: 5,
            label: (0, $aol72.getProductName)(5)
        },
        {
            value: 8,
            label: (0, $aol72.getProductName)(8)
        },
        {
            value: 6,
            label: (0, $aol72.getProductName)(6)
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "row margin-bottom-small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("form", {
        name: "form",
        role: "form",
        noValidate: true,
        onSubmit: handleSubmit(onSubmit)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $4MH4b.default), {
        placeholder: text("lblSerialNumber"),
        "data-testid": "input-serial",
        id: "deviceSerialNumber",
        key: "device SerialNumber",
        ...register("serialNumber")
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $4MH4b.default), {
        placeholder: text("lblName"),
        "data-testid": "input-name",
        id: "deviceName",
        key: "device Name",
        ...register("name")
    })), !(0, $8LupL.isAdminDomain) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $4MH4b.default), {
        placeholder: text("lblOrganisation"),
        "data-testid": "input-organisation",
        id: "deviceCompanyName",
        key: "device CompanyName",
        ...register("companyName")
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $4MH4b.default), {
        placeholder: text("lblPartnerField"),
        "data-testid": "input-serial",
        id: "devicePartner",
        key: "device Partner",
        ...register("partnerName")
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "col-xs-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cbVaW.Controller), {
        name: "status",
        control: control,
        render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
                className: "form-group"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("select", {
                title: "deviceStatus",
                name: "deviceStatus",
                className: "form-control",
                onChange: onChange,
                value: value ?? 0
            }, statuses.map((status, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("option", {
                    value: status.value,
                    key: index
                }, status.label))))
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "col-xs-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cbVaW.Controller), {
        name: "productId",
        control: control,
        render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
                className: "form-group"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("select", {
                title: "deviceProduct",
                name: "deviceProduct",
                className: "form-control",
                onChange: onChange,
                value: value ?? 0
            }, measurementDevicesProducts.map((product, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("option", {
                    value: product.value,
                    key: index
                }, product.label))))
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "col-xs-12 col-md-4 pull-right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-actions"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "pull-right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("button", {
        className: "btn btn-ok btn-sm",
        type: "submit"
    }, loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", {
        className: "fa fa-spinner fa-pulse",
        "data-testid": "btn-search"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "btnSearch"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("button", {
        className: "btn btn-ok btn-sm margin-2",
        type: "button",
        "data-testid": "btn-clear",
        onClick: ()=>{
            clearDevice();
            reset();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "btnClear"
    }))))))));
});

});
parcelRegister("4MH4b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8ed20ab2e5771ff$export$2e2bcd8739ae039; });

var $6uMv9 = parcelRequire("6uMv9");
const $a8ed20ab2e5771ff$var$SearchInput = /*#__PURE__*/ (0, $6uMv9.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "col-xs-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("input", {
        ref: ref,
        type: "text",
        placeholder: props.placeholder,
        id: props.id,
        className: "form-control",
        value: props.value,
        name: props.name,
        ...props.onChange && {
            onChange: props.onChange
        },
        ...props.dataTestId && {
            "data-testid": props.dataTestId
        }
    })));
});
var $a8ed20ab2e5771ff$export$2e2bcd8739ae039 = $a8ed20ab2e5771ff$var$SearchInput;

});



parcelRegister("8MU0a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a315a598895bfcb1$export$2e2bcd8739ae039; });
var $a315a598895bfcb1$export$2e2bcd8739ae039 = (callback)=>(event)=>{
        event.preventDefault();
        return callback && callback(event);
    };

});


var $6uMv9 = parcelRequire("6uMv9");

var $fXJGT = parcelRequire("fXJGT");

var $iZaUM = parcelRequire("iZaUM");

var $4vH3e = parcelRequire("4vH3e");

var $cFTyZ = parcelRequire("cFTyZ");

var $edR9j = parcelRequire("edR9j");

var $iQS7O = parcelRequire("iQS7O");

var $dcOIZ = parcelRequire("dcOIZ");

var $iAZE5 = parcelRequire("iAZE5");

var $3jZfA = parcelRequire("3jZfA");

var $6uMv9 = parcelRequire("6uMv9");

var $4vH3e = parcelRequire("4vH3e");

var $84v65 = parcelRequire("84v65");
var $iZaUM = parcelRequire("iZaUM");

var $7Al71 = parcelRequire("7Al71");

var $iFhrk = parcelRequire("iFhrk");

var $73srW = parcelRequire("73srW");

var $7Xmh2 = parcelRequire("7Xmh2");

var $ieBDX = parcelRequire("ieBDX");

var $d1vMk = parcelRequire("d1vMk");

var $bMIKZ = parcelRequire("bMIKZ");

var $4yml8 = parcelRequire("4yml8");

var $8XNZy = parcelRequire("8XNZy");

var $2vwem = parcelRequire("2vwem");

var $6Sp0E = parcelRequire("6Sp0E");

var $lVzQC = parcelRequire("lVzQC");

var $ckDUJ = parcelRequire("ckDUJ");

var $klmJ0 = parcelRequire("klmJ0");

var $1iE9F = parcelRequire("1iE9F");

var $6uMv9 = parcelRequire("6uMv9");

var $174na = parcelRequire("174na");

var $7UisG = parcelRequire("7UisG");
function $9459cedc4eb36344$var$AdminPageHeader({ className: className, style: style }) {
    const MENU_LINKS = [
        {
            href: "/dashboard",
            labelCode: "btnDashboard"
        },
        {
            href: "/chargepoints",
            labelCode: "btnChargers"
        },
        {
            href: "/pools",
            labelCode: "btnPools"
        },
        {
            href: "/users",
            labelCode: "btnUsers"
        },
        {
            href: "/nfcTags",
            labelCode: "btnRFID"
        },
        {
            href: "/loadbalancer",
            labelCode: "btnLoadbalancer"
        },
        {
            href: "/measurementDevices",
            labelCode: "btnMeasurementDevices"
        },
        {
            href: "/reports",
            labelCode: "btnReports"
        },
        {
            href: "/settings",
            labelCode: "btnSettings"
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $7UisG.PageHeader), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($174na)))(className),
        style: style,
        links: MENU_LINKS
    });
}
var $9459cedc4eb36344$export$2e2bcd8739ae039 = $9459cedc4eb36344$var$AdminPageHeader;



var $6uMv9 = parcelRequire("6uMv9");

var $174na = parcelRequire("174na");

var $akcQ4 = parcelRequire("akcQ4");

var $iZaUM = parcelRequire("iZaUM");

var $li3ww = parcelRequire("li3ww");

var $bhqzv = parcelRequire("bhqzv");
const $8198a3b1ae453be8$var$acceptInvitation = (invitationToken)=>(0, $bhqzv.default)({
        method: "PUT",
        path: `/auth/invitation/accept/${invitationToken}`
    });
var $8198a3b1ae453be8$export$2e2bcd8739ae039 = $8198a3b1ae453be8$var$acceptInvitation;



var $ka0YZ = parcelRequire("ka0YZ");

var $1xw2Y = parcelRequire("1xw2Y");

var $jyUmz = parcelRequire("jyUmz");

var $aL1Vp = parcelRequire("aL1Vp");
const $18a00e9f2cf48270$var$Container = (0, $akcQ4.default).div`
    width: 440px;
    font-family: 'Lateral';
    font-size: 14px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    padding: 10px;
`;
const $18a00e9f2cf48270$var$ReturnButton = (0, $akcQ4.default).div`
    color: ${({ theme: theme })=>theme.font.midDarkColor};
    font-weight: 400;
    font-size: 16px;

    &:hover {
        cursor: pointer;
    }
`;
function $18a00e9f2cf48270$export$49b43be1058c84eb({ className: className, style: style }) {
    const text = (0, $aL1Vp.default)();
    const navigate = (0, $iZaUM.useNavigate)();
    const [searchParams] = (0, $iZaUM.useSearchParams)();
    const [message, setMessage] = (0, $6uMv9.useState)({
        type: undefined,
        message: ""
    });
    const acceptInvitationRequest = (0, $ka0YZ.default)((token)=>(0, $8198a3b1ae453be8$export$2e2bcd8739ae039)(token));
    (0, $6uMv9.useEffect)(()=>{
        const token = searchParams.get("token");
        if (token) acceptInvitationRequest.execute(token).catch(()=>{});
        else setMessage({
            type: "error",
            message: text("msgInviteNotAccepted")
        });
    }, []);
    (0, $6uMv9.useEffect)(()=>{
        if (acceptInvitationRequest.status === (0, $ka0YZ.Status).SUCCESS) setMessage({
            type: "success",
            message: "msgInviteAccepted"
        });
        if (acceptInvitationRequest.status === (0, $ka0YZ.Status).ERROR) setMessage({
            type: "error",
            message: "msgInviteNotAccepted"
        });
    }, [
        acceptInvitationRequest.status
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $li3ww.LandingPageLayout), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($174na)))(className),
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($18a00e9f2cf48270$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $jyUmz.FormHeader), null), message.type && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $li3ww.SNotification), {
        error: message.type === "error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: message.message
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($18a00e9f2cf48270$var$ReturnButton, {
        onClick: ()=>navigate("/login")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "btnReturnToSignIn"
    }))));
}





var $6uMv9 = parcelRequire("6uMv9");

var $4vH3e = parcelRequire("4vH3e");

var $fvmYM = parcelRequire("fvmYM");

var $hyWja = parcelRequire("hyWja");

var $1xw2Y = parcelRequire("1xw2Y");

var $52Dbq = parcelRequire("52Dbq");

var $2dcsx = parcelRequire("2dcsx");

var $4onjs = parcelRequire("4onjs");

var $g26M3 = parcelRequire("g26M3");
parcelRequire("bOBEI");
var $77EIr = parcelRequire("77EIr");

var $akcQ4 = parcelRequire("akcQ4");
const $9522042c0b2a27a4$export$1e86fd0e1db89578 = (0, $akcQ4.default).div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;

    font-weight: 300;
    font-size: 1rem;
`;
const $9522042c0b2a27a4$export$8ba719520b473d7d = (0, $akcQ4.default).div`
    margin-bottom: 40px;
    display: flex;
    flex-direction: column;
`;
const $9522042c0b2a27a4$export$61b0b4c79441baec = (0, $akcQ4.default).div`
    height: ${({ size: size })=>size === "sm" ? "16px" : "36px"};
    width: 337px;
    align-self: center;
    margin-bottom: 24px;
    border-radius: 16px;
`;


const $83748f3a781d02af$export$fedd53519a0e2bce = /*#__PURE__*/ (0, $6uMv9.memo)(function DashboardPage() {
    const companyId = (0, $4vH3e.useSelector)((state)=>state.user.selectedCompanyId);
    const { data: totalConsumtionData, isLoading: isLoading } = (0, $fvmYM.useStatisticsGetCompanyTotalConsumptionQuery)({
        companyId: companyId
    });
    const { data: chargePointStatistics } = (0, $fvmYM.useStatisticsGetChargePointStatusStatsForCompanyQuery)({
        companyId: companyId
    });
    const { data: companyStatistics } = (0, $fvmYM.useStatisticsGetCompanyUsageStatisticsQuery)({
        companyId: companyId
    });
    (0, $6uMv9.useEffect)(()=>{
        if (totalConsumtionData?.consumptionPerChargePoint?.length) {
            const data = totalConsumtionData.consumptionPerChargePoint;
            const dyGraphCurrentData = data.map((item, index)=>[
                    index + 1,
                    item.totalConsumptionKwh ?? 0
                ]);
            const xToIdMapper = data.reduce((map, item, index)=>{
                return Object.assign(map, {
                    [index + 1]: item.chargePointId ?? ""
                });
            }, {});
            (0, $2dcsx.configureChart)(dyGraphCurrentData, // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            xToIdMapper, "lastSevenDaysGraph", 100, 80, true, "legendSevenDays", "kWh");
        }
    }, [
        totalConsumtionData
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $52Dbq.PageLayoutContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "col-xs-12 col-md-10"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "row"
    }, !isLoading && totalConsumtionData?.totalConsumption && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $9522042c0b2a27a4$export$8ba719520b473d7d), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $9522042c0b2a27a4$export$1e86fd0e1db89578), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $hyWja.Header), {
        code: "lblTotalConsumptionForMonth"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "msgClickAndDrugToZoom"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2dcsx.BarChart), {
        barChartId: "lastMonthGraph",
        data: totalConsumtionData?.totalConsumption,
        useMonth: false
    })), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $9522042c0b2a27a4$export$8ba719520b473d7d), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $9522042c0b2a27a4$export$61b0b4c79441baec), {
        className: "shimmer-container shimmer-xs",
        size: "md"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $9522042c0b2a27a4$export$61b0b4c79441baec), {
        className: "shimmer-container shimmer-xs",
        size: "sm"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $77EIr.WidgetLoadingState), {
        height: "320px"
    })), !isLoading && totalConsumtionData?.consumptionPerChargePoint && totalConsumtionData?.consumptionPerChargePoint?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $9522042c0b2a27a4$export$8ba719520b473d7d), {
        className: "margin-top-xlarge"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $9522042c0b2a27a4$export$1e86fd0e1db89578), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $hyWja.Header), {
        code: "lblConsumptionPerCharger"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "msgClickAndDrugToZoom"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "text-center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        id: "legendSevenDays",
        className: "legend-one-month"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        id: "lastSevenDaysGraph",
        className: "admin-dashboard-graph",
        style: {
            width: "95%"
        },
        "data-testid": "bar-chart"
    }))), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $9522042c0b2a27a4$export$8ba719520b473d7d), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $9522042c0b2a27a4$export$61b0b4c79441baec), {
        className: "shimmer-container shimmer-xs",
        size: "md"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $9522042c0b2a27a4$export$61b0b4c79441baec), {
        className: "shimmer-container shimmer-xs",
        size: "sm"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $77EIr.WidgetLoadingState), {
        height: "320px"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "col-xs-12 col-md-2 stats-widget"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $4onjs.ChargePointStatusDashboardWidget), {
        chargePointStatusStats: chargePointStatistics
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $g26M3.ChargingStatistics), {
        stats: companyStatistics,
        direction: "column"
    }))));
});





var $6uMv9 = parcelRequire("6uMv9");

var $174na = parcelRequire("174na");

var $4vH3e = parcelRequire("4vH3e");

var $7ijgp = parcelRequire("7ijgp");

var $aIcGc = parcelRequire("aIcGc");

var $iZaUM = parcelRequire("iZaUM");

var $lG0u6 = parcelRequire("lG0u6");

var $eao00 = parcelRequire("eao00");

var $li3ww = parcelRequire("li3ww");

var $3T04t = parcelRequire("3T04t");

var $fvmYM = parcelRequire("fvmYM");

var $6nGY6 = parcelRequire("6nGY6");

var $jyqsN = parcelRequire("jyqsN");

var $aL1Vp = parcelRequire("aL1Vp");

var $jyUmz = parcelRequire("jyUmz");
const $f8186f2222fd08ed$export$d89e43e3db240a63 = /*#__PURE__*/ (0, $6uMv9.memo)(function SelectOrganisationPage({ className: className, style: style }) {
    const text = (0, $aL1Vp.default)();
    const navigate = (0, $iZaUM.useNavigate)();
    const location = (0, $iZaUM.useLocation)();
    const from = location?.state?.from || "/";
    const [selectedOrganisation, setSelectedOrganisation] = (0, $6uMv9.useState)(null);
    const { data: organisations, isLoading: isLoading } = (0, $fvmYM.useCompanyGetAdministratedCompaniesQuery)();
    const dispatch = (0, $4vH3e.useDispatch)();
    (0, $6uMv9.useEffect)(()=>{
        // handle logged in scenario
        const user = (0, $eao00.default)();
        if (user?.selectedCompanyId) navigate(from || "/dashboard", {
            replace: true
        });
    }, [
        from,
        navigate
    ]);
    const signedInUser = (0, $4vH3e.useSelector)((state)=>state.user);
    const handleSubmit = (event)=>{
        event.preventDefault();
        if (!signedInUser || !selectedOrganisation) {
            navigate("/login", {
                replace: true
            });
            return;
        }
        const userAfterSelectCompany = {
            ...signedInUser,
            selectedCompanyId: selectedOrganisation?.id ?? ""
        };
        (0, $eao00.default)(userAfterSelectCompany);
        dispatch((0, $jyqsN.setUser)(userAfterSelectCompany));
        navigate(from || "/dashboard", {
            replace: true
        });
        (0, $6nGY6.triggerAuthChange)();
    };
    const organisationOptions = organisations?.map((organisation)=>({
            label: organisation?.name,
            value: organisation
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $li3ww.LandingPageLayout), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($174na)))(className),
        style: style,
        background: (0, $lG0u6.theme).whiteBackground,
        hideLanguageSelect: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "sm:w-8 md:w-6 w-11"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $jyUmz.FormHeader), {
        className: "mb-8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("form", {
        onSubmit: handleSubmit,
        noValidate: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $7ijgp.Dropdown), {
        className: "w-full",
        options: organisationOptions,
        value: selectedOrganisation,
        onChange: (option)=>setSelectedOrganisation(option.value),
        loading: isLoading,
        filter: true,
        virtualScrollerOptions: {
            itemSize: 38
        },
        placeholder: text("lblSelectOrganisation")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "flex flex-column gap-4 justify-content-center align-items-center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $aIcGc.Button), {
        disabled: !selectedOrganisation || isLoading,
        type: "submit",
        className: "mt-5",
        label: text("btnNext"),
        iconPos: "right",
        icon: "pi pi-arrow-right"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $aIcGc.Button), {
        link: true,
        label: text("btnSignOut"),
        "data-testid": "btn-logout",
        onClick: ()=>{
            (0, $3T04t.signOut)();
        }
    })))));
});





var $174na = parcelRequire("174na");

var $6uMv9 = parcelRequire("6uMv9");

var $4vH3e = parcelRequire("4vH3e");

var $iZaUM = parcelRequire("iZaUM");

var $fvmYM = parcelRequire("fvmYM");

var $2460e = parcelRequire("2460e");

var $k0EDO = parcelRequire("k0EDO");

var $52Dbq = parcelRequire("52Dbq");

var $2naDF = parcelRequire("2naDF");

var $3YfCm = parcelRequire("3YfCm");

var $1xw2Y = parcelRequire("1xw2Y");

var $6uMv9 = parcelRequire("6uMv9");

var $iZaUM = parcelRequire("iZaUM");

var $8gLAc = parcelRequire("8gLAc");

var $6uMv9 = parcelRequire("6uMv9");

var $4vH3e = parcelRequire("4vH3e");

var $cbVaW = parcelRequire("cbVaW");

var $7Ilk7 = parcelRequire("7Ilk7");

var $hJq0b = parcelRequire("hJq0b");

var $1xw2Y = parcelRequire("1xw2Y");

var $fvmYM = parcelRequire("fvmYM");

var $f7UZA = parcelRequire("f7UZA");

var $2460e = parcelRequire("2460e");

var $iktXR = parcelRequire("iktXR");

var $aL1Vp = parcelRequire("aL1Vp");
const $febe6b5ec782b74e$export$13144779a2e61869 = /*#__PURE__*/ (0, $6uMv9.memo)(function PoolDetailsWidget({ save: save, cancel: cancel, poolValue: poolValue, poolName: poolName, locationCheck: locationCheck }) {
    const text = (0, $aL1Vp.default)();
    const userCompanyId = (0, $4vH3e.useSelector)((state)=>state.user.selectedCompanyId);
    const [addNewPool] = (0, $fvmYM.usePoolCreateMutation)();
    const [editPool] = (0, $fvmYM.usePoolUpdateMutation)();
    const schema = $7Ilk7.object().shape({
        name: $7Ilk7.string().required(text("msgNameRequired"))
    });
    const { register: register, handleSubmit: handleSubmit, formState: { isDirty: isDirty, isValid: isValid, errors: errors } } = (0, $cbVaW.useForm)({
        mode: "all",
        resolver: (0, $hJq0b.yupResolver)(schema, {
            abortEarly: false
        }),
        values: {
            ...poolValue,
            name: poolName,
            companyId: userCompanyId
        }
    });
    const onSubmit = async (data)=>{
        if (!poolValue && !poolName) try {
            await addNewPool({
                pool: data
            }).unwrap();
            save();
        } catch (e) {
            (0, $2460e.notifyError)(text("msgPoolNotCreated"));
        }
        if (poolValue) try {
            await editPool({
                pool: {
                    ...poolValue,
                    name: data.name
                }
            }).unwrap();
            save();
        } catch (e) {
            (0, $2460e.notifyError)(text("msgPoolNotUpdated"));
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("form", {
        onSubmit: handleSubmit(onSubmit)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iktXR.default), {
        ...register("name"),
        id: "input-name",
        "data-testid": "name-input",
        labelText: text("lblName"),
        autoComplete: "off",
        required: true,
        error: errors.name?.message
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "modal-footer mt-6"
    }, locationCheck && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
        "data-testid": "cancel-btn",
        primary: false,
        size: "sm",
        onClick: ()=>cancel && cancel()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "btnCancel"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
        type: "submit",
        "data-testid": "save-btn",
        size: "sm",
        disabled: !isValid || !isDirty
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "btnSave"
    }))));
});



var $aL1Vp = parcelRequire("aL1Vp");
const $6c1897a5d7b432d1$export$cea4a69fb036e34d = /*#__PURE__*/ (0, $6uMv9.memo)(function AddEditPoolModal({ save: save, cancel: cancel, poolValue: poolValue }) {
    const text = (0, $aL1Vp.default)();
    const navigate = (0, $iZaUM.useNavigate)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8gLAc.default), {
        title: poolValue ? text("lblPoolModal", {
            name: poolValue.name
        }) : text("lblNewPoolModal"),
        size: "md"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $febe6b5ec782b74e$export$13144779a2e61869), {
        cancel: cancel,
        save: save,
        poolValue: poolValue,
        locationCheck: ()=>{
            navigate("/pools");
        }
    }));
});



var $aL1Vp = parcelRequire("aL1Vp");
const $fc8cf465af1d1012$export$4c210577356eef88 = /*#__PURE__*/ (0, $6uMv9.memo)(function PoolsPage({ className: className, style: style }) {
    const text = (0, $aL1Vp.default)();
    const user = (0, $4vH3e.useSelector)((state)=>state.user);
    const [openAddModal, setOpenAddModal] = (0, $6uMv9.useState)(false);
    const cancel = ()=>setOpenAddModal(false);
    const { currentData: pools, refetch: refetch } = (0, $fvmYM.useCompanyGetPoolsQuery)({
        companyId: user?.selectedCompanyId
    }, {
        skip: !user.selectedCompanyId
    });
    const [removePool] = (0, $fvmYM.usePoolDeletePoolMutation)();
    const save = ()=>{
        (0, $2460e.notifySuccess)(text("msgPoolAdded"));
        refetch();
        setOpenAddModal(false);
    };
    const removePools = async (poolId)=>{
        if (confirm(text("msgRemovePool"))) try {
            await removePool({
                poolId: poolId,
                companyId: user.selectedCompanyId
            }).unwrap();
            (0, $2460e.notifySuccess)(text("msgPoolRemoved"));
            refetch();
        } catch (e) {
            console.error(e);
            (0, $2460e.notifyError)(text("msgPoolNotRemoved"));
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $52Dbq.PageLayoutContainer), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($174na)))(className),
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $3YfCm.WidgetLayout), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
            code: "lblPoolsPage"
        }),
        headerButtons: [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $k0EDO.Button), {
                code: "btnAdd",
                "data-testid": "add-icon",
                small: true,
                onClick: ()=>setOpenAddModal(true)
            })
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.Table), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblName"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBody), null, pools?.map((pool)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), {
            key: pool.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iZaUM.Link), {
            "data-testid": "name-pools",
            to: `/pool/${pool.id}`,
            className: "pointer table btn-link"
        }, pool.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
            className: "flex justify-content-end mr-3"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("button", {
            "data-testid": "remove-pools",
            type: "button",
            "data-toggle": "tooltip",
            "data-placement": "top",
            title: text("btnRemove"),
            className: "btn btn-danger btn-xs btn-icon",
            onClick: ()=>removePools(pool.id)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", {
            className: "fa fa-remove"
        })))))))), openAddModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $6c1897a5d7b432d1$export$cea4a69fb036e34d), {
        cancel: cancel,
        save: save
    })));
});





var $6uMv9 = parcelRequire("6uMv9");

var $174na = parcelRequire("174na");

var $iZaUM = parcelRequire("iZaUM");
var $84v65 = parcelRequire("84v65");

var $52Dbq = parcelRequire("52Dbq");


var $3YfCm = parcelRequire("3YfCm");

var $fvmYM = parcelRequire("fvmYM");

var $gVguk = parcelRequire("gVguk");

var $1xw2Y = parcelRequire("1xw2Y");

var $2460e = parcelRequire("2460e");

var $6uMv9 = parcelRequire("6uMv9");

var $4vH3e = parcelRequire("4vH3e");

var $8gLAc = parcelRequire("8gLAc");

var $fvmYM = parcelRequire("fvmYM");

var $2naDF = parcelRequire("2naDF");

var $jeXdk = parcelRequire("jeXdk");

var $1xw2Y = parcelRequire("1xw2Y");

var $dfOhE = parcelRequire("dfOhE");

var $d6sTr = parcelRequire("d6sTr");

var $f7UZA = parcelRequire("f7UZA");

var $4CNFe = parcelRequire("4CNFe");

var $35vY7 = parcelRequire("35vY7");
parcelRequire("acee3");
var $6IEar = parcelRequire("6IEar");

var $iktXR = parcelRequire("iktXR");

var $aL1Vp = parcelRequire("aL1Vp");
const $70ff5f79f3a83383$export$19d80baaf1744f2f = /*#__PURE__*/ (0, $6uMv9.memo)(function AddEditPoolModal({ onAdd: onAdd, onCancel: onCancel }) {
    const text = (0, $aL1Vp.default)();
    (0, $4CNFe.default)({
        onEscapePress: onCancel
    });
    const companyId = (0, $4vH3e.useSelector)((state)=>state.user.selectedCompanyId);
    const { data: chargePoints, isLoading: isLoadingChargePoints } = (0, $fvmYM.useCompanyGetChargePointsPagedQuery)({
        companyId: companyId
    }, {
        refetchOnMountOrArgChange: true
    });
    const [filteredChargePoints, setFilteredChargePoints] = (0, $6uMv9.useState)([]);
    const [searchValue, setSearchValue] = (0, $6uMv9.useState)("");
    const [currentPage, setCurrentPage] = (0, $6uMv9.useState)(0);
    const [pageSize] = (0, $6uMv9.useState)(10);
    const offset = currentPage * pageSize;
    (0, $6uMv9.useEffect)(()=>{
        setFilteredChargePoints(()=>{
            return chargePoints ? chargePoints?.items?.filter((cp)=>cp.poolId === null && (0, $6IEar.filterFieldsBySearchValue)([
                    cp.id,
                    cp.name
                ], searchValue)) : [];
        });
    }, [
        chargePoints,
        offset,
        pageSize,
        searchValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8gLAc.default), {
        title: text("lblAddChargePoint"),
        size: "lg",
        actions: [
            {
                label: text("btnCancel"),
                btn: "btn-secondary",
                callback: onCancel
            }
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "row margin-bottom-small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "w-12 md:w-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iktXR.default), {
        "data-testid": "search",
        type: "text",
        name: "search",
        id: "search",
        labelText: text("msgSearch"),
        value: searchValue,
        onChange: (event)=>{
            setCurrentPage(0);
            setSearchValue(event.target.value);
        }
    }))), isLoadingChargePoints ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "shimmer-container shimmer-small"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.Table), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblSerialNumberShort"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblStatus"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblSettings"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblLastSeenTime"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblName"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBody), null, filteredChargePoints && filteredChargePoints?.slice(offset, offset + pageSize).map((chargePoint, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, chargePoint.id), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $jeXdk.ChargepointStatus), {
            chargePoint: chargePoint || ""
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $d6sTr.default), {
            chargePoint: chargePoint || ""
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, chargePoint?.chargePointStatus === "Offline" && (0, $dfOhE.default)(chargePoint?.lastHeartbeat || "") || "---"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            className: "hide-overflow"
        }, chargePoint?.name || ""), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
            "data-testid": `add-button-charger-${chargePoint.id}`,
            size: "xs",
            onClick: ()=>{
                onAdd(chargePoint);
            }
        }, text("btnAdd"))))))), filteredChargePoints.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $35vY7.ChargersPagination), {
        totalCount: filteredChargePoints?.length,
        pageSize: pageSize,
        pageIndex: currentPage,
        displayedChargers: pageSize,
        setPageIndex: (index)=>{
            setCurrentPage(index);
        }
    }));
});



var $aL1Vp = parcelRequire("aL1Vp");
const $a6f1b77cf073a9bb$export$72fb5ffeaac1b378 = /*#__PURE__*/ (0, $6uMv9.memo)(function PoolPageProps(props) {
    const text = (0, $aL1Vp.default)();
    const navigate = (0, $iZaUM.useNavigate)();
    const [addChargersModalIsOpened, setAddChargersModalIsOpened] = (0, $6uMv9.useState)(false);
    const { poolId: currentPoolId } = (0, $84v65.useParams)();
    const { data: poolChargePoints } = (0, $fvmYM.usePoolGetChargePointsQuery)({
        poolId: currentPoolId
    }, {
        refetchOnMountOrArgChange: true
    });
    const { currentData: poolById } = (0, $fvmYM.usePoolGetByIdQuery)({
        poolId: currentPoolId
    });
    const [addChargePointToPool] = (0, $fvmYM.useChargePointAddToPoolMutation)();
    const saveEdit = ()=>{
        (0, $2460e.notifySuccess)(text("msgPoolUpdated"));
    };
    const handleAddChargerToPool = (chargePoint)=>{
        addChargePointToPool({
            chargePointId: chargePoint.id,
            poolId: currentPoolId
        }).unwrap().then(()=>{
            (0, $2460e.notifySuccess)(text("lblChargerWasAddedToPool"));
        }).catch(()=>(0, $2460e.notifyError)("msgChargerFailedToAddToPool"));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $52Dbq.PageLayoutContainer), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($174na)))(props.className),
        style: props.style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "row margin-bottom-small margin-right-small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "pull-right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("button", {
        type: "button",
        "data-testid": "back-btn",
        className: "btn btn-ok btn-sm",
        onClick: ()=>navigate("/pools")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "btnBack"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $3YfCm.WidgetLayout), {
        title: text("lblPoolPage", {
            name: poolById?.name
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $febe6b5ec782b74e$export$13144779a2e61869), {
        save: saveEdit,
        poolName: poolById?.name,
        poolValue: poolById
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $gVguk.ChargersListWidget), {
        poolChargePoints: poolChargePoints,
        onAddChargerToPool: ()=>setAddChargersModalIsOpened(true)
    }), addChargersModalIsOpened && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $70ff5f79f3a83383$export$19d80baaf1744f2f), {
        onAdd: (chargePoint)=>handleAddChargerToPool(chargePoint),
        onCancel: ()=>setAddChargersModalIsOpened(false)
    })));
});





var $6uMv9 = parcelRequire("6uMv9");

var $4vH3e = parcelRequire("4vH3e");

var $gnU93 = parcelRequire("gnU93");

var $52Dbq = parcelRequire("52Dbq");
parcelRequire("9J2qy");
var $fZJUc = parcelRequire("fZJUc");

var $fvmYM = parcelRequire("fvmYM");
const $669e5c4117a99b3c$var$defaultFiltersValue = {
    serialNumber: "",
    companyId: "",
    limit: 500,
    name: "",
    status: undefined
};
const $669e5c4117a99b3c$export$8de4554fe05e44f8 = /*#__PURE__*/ (0, $6uMv9.memo)(function MeasurementDevicesPage({ style: style }) {
    const user = (0, $4vH3e.useSelector)((state)=>state.user);
    const [filter, setFilter] = (0, $6uMv9.useState)($669e5c4117a99b3c$var$defaultFiltersValue);
    const [currentPage, setCurrentPage] = (0, $6uMv9.useState)(0);
    const filtersContainerRef = (0, $6uMv9.useRef)(null);
    const handlePageClick = (selected)=>{
        window.scrollTo(0, filtersContainerRef.current?.offsetTop || 0);
        setCurrentPage(selected);
    };
    const pageClick = ()=>{
        setCurrentPage(0);
    };
    const handleFilterSubmit = (filters)=>{
        setFilter(filters);
        pageClick();
    };
    const { currentData: deviceData = [], isLoading: deviceFetching } = (0, $fvmYM.useMeasurementDevicesGetFilteredQuery)({
        ...filter,
        companyId: user?.selectedCompanyId,
        limit: $669e5c4117a99b3c$var$defaultFiltersValue.limit
    }, {
        refetchOnMountOrArgChange: true
    });
    const clearDevices = ()=>{
        setFilter($669e5c4117a99b3c$var$defaultFiltersValue);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $52Dbq.PageLayoutContainer), {
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $fZJUc.MeasurementDeviceSearchListForm), {
        onSubmit: handleFilterSubmit,
        clearDevice: clearDevices,
        loading: deviceFetching
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $gnU93.MeasurementDevicesTableWidget), {
        data: deviceData ?? [],
        currentPage: currentPage,
        handlePageClick: handlePageClick,
        pageClick: pageClick,
        loading: deviceFetching
    }));
});





var $6uMv9 = parcelRequire("6uMv9");

var $akcQ4 = parcelRequire("akcQ4");

var $4vH3e = parcelRequire("4vH3e");

var $lWDz3 = parcelRequire("lWDz3");

var $iJ6Cm = parcelRequire("iJ6Cm");

var $iZaUM = parcelRequire("iZaUM");

var $2naDF = parcelRequire("2naDF");

var $5P7fB = parcelRequire("5P7fB");
const $7b817a5f2440b094$var$initialState = {
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    password: "",
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    passwordCompare: "",
    roleInCompany: "",
    userStatus: "New"
};
const $7b817a5f2440b094$export$72a4433635166412 = (0, $5P7fB.createSlice)({
    name: "selectedUser",
    initialState: $7b817a5f2440b094$var$initialState,
    reducers: {
        setSelectedUser: (_, action)=>{
            return {
                ...action.payload
            };
        },
        resetSelectedUser: ()=>{
            return {
                ...$7b817a5f2440b094$var$initialState
            };
        }
    }
});
const { setSelectedUser: $7b817a5f2440b094$export$cb57a0abd67769d3, resetSelectedUser: $7b817a5f2440b094$export$d2e2801f8995a0fa } = $7b817a5f2440b094$export$72a4433635166412.actions;
var $7b817a5f2440b094$export$2e2bcd8739ae039 = $7b817a5f2440b094$export$72a4433635166412.reducer;



var $fvmYM = parcelRequire("fvmYM");
parcelRequire("acee3");
var $6IEar = parcelRequire("6IEar");

var $52Dbq = parcelRequire("52Dbq");

var $2llRK = parcelRequire("2llRK");

var $hBKXa = parcelRequire("hBKXa");

var $3YfCm = parcelRequire("3YfCm");

var $k0EDO = parcelRequire("k0EDO");

var $iFhrk = parcelRequire("iFhrk");

var $1xw2Y = parcelRequire("1xw2Y");

var $aL1Vp = parcelRequire("aL1Vp");

var $2460e = parcelRequire("2460e");
var $df1fee63ce6dbb8d$var$SortParameter;
(function(SortParameter) {
    SortParameter["FIRSTNAME"] = "firstName";
    SortParameter["EMAIL"] = "email";
    SortParameter["MOBILE"] = "mobile";
})($df1fee63ce6dbb8d$var$SortParameter || ($df1fee63ce6dbb8d$var$SortParameter = {}));
const $df1fee63ce6dbb8d$var$SIcon = (0, $akcQ4.default)((0, $lWDz3.FontAwesomeIcon))`
    margin-left: 4px;
`;
const $df1fee63ce6dbb8d$export$107317390f5aa598 = /*#__PURE__*/ (0, $6uMv9.memo)(function AdminUsersWidget() {
    const text = (0, $aL1Vp.default)();
    const navigate = (0, $iZaUM.useNavigate)();
    const dispatch = (0, $4vH3e.useDispatch)();
    const [searchValue, setSearchValue] = (0, $6uMv9.useState)("");
    const [sortFilter, setSortFilter] = (0, $6uMv9.useState)({
        parameter: "email",
        reversed: false
    });
    const user = (0, $4vH3e.useSelector)((state)=>state.user);
    const isAdmin = (0, $2llRK.default)(user, user.selectedCompanyId, (0, $iFhrk.default).Admin);
    const { data: users, isFetching: loading, refetch: refetch } = (0, $fvmYM.useCompanyGetUsersQuery)({
        companyId: user?.selectedCompanyId
    }, {
        skip: !user.selectedCompanyId,
        refetchOnMountOrArgChange: true
    });
    const [removeUser] = (0, $fvmYM.useCompanyRemoveUserMutation)();
    const removeUserValue = async (userId)=>{
        if (confirm(text("msgRemoveUser"))) try {
            await removeUser({
                userId: userId,
                companyId: user.selectedCompanyId
            }).unwrap();
            (0, $2460e.notifySuccess)(text("msgUserRemoved"));
            refetch();
        } catch (error) {
            const errormessage = error?.data.messageCode;
            if (errormessage === "msgUserWithMDCantBeRemovedFromCompany") {
                (0, $2460e.notifyError)(text("msgUserWithMDCantBeRemovedFromCompany"));
                return;
            }
            if (errormessage === "msgUserWithTagsCantBeRemovedFromCompany") {
                (0, $2460e.notifyError)(text("msgUserWithTagsCantBeRemovedFromCompany"));
                return;
            } else {
                (0, $2460e.notifyError)(text("msgUserNotRemoved"));
                return;
            }
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $52Dbq.PageLayoutContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $3YfCm.WidgetLayout), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
            code: "lblUsersPage"
        }),
        headerButtons: [
            isAdmin ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $k0EDO.Button), {
                onClick: ()=>{
                    dispatch((0, $7b817a5f2440b094$export$d2e2801f8995a0fa)());
                    navigate("/user");
                },
                code: "btnAdd",
                "data-testid": "add-icon",
                small: true
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).Fragment, null)
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "row margin-bottom-small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "col-xs-12 col-md-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("input", {
        "data-testid": "search",
        type: "text",
        name: "search",
        id: "search",
        className: "form-control",
        value: searchValue,
        onChange: (event)=>setSearchValue(event.target.value),
        placeholder: text("msgSearch")
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.Table), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("a", {
        "data-testid": "name",
        onClick: ()=>setSortFilter({
                parameter: "firstName",
                reversed: !sortFilter?.reversed
            }),
        className: "pointer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblName"
    }), sortFilter?.parameter === "firstName" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($df1fee63ce6dbb8d$var$SIcon, {
        "data-testid": "icon-name",
        icon: sortFilter.reversed ? (0, $iJ6Cm.faCaretUp) : (0, $iJ6Cm.faCaretDown)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("a", {
        "data-testid": "email",
        onClick: ()=>setSortFilter({
                parameter: "email",
                reversed: !sortFilter?.reversed
            }),
        className: "pointer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblEmail"
    }), sortFilter?.parameter === "email" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($df1fee63ce6dbb8d$var$SIcon, {
        "data-testid": "icon-email",
        icon: sortFilter.reversed ? (0, $iJ6Cm.faCaretUp) : (0, $iJ6Cm.faCaretDown)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("a", {
        "data-testid": "mobile",
        onClick: ()=>setSortFilter({
                parameter: "mobile",
                reversed: !sortFilter?.reversed
            }),
        className: "pointer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblMobile"
    }), sortFilter?.parameter === "mobile" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($df1fee63ce6dbb8d$var$SIcon, {
        "data-testid": "icon-mobile",
        icon: sortFilter.reversed ? (0, $iJ6Cm.faCaretUp) : (0, $iJ6Cm.faCaretDown)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblStatus"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblRole"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblDelete"
    })))), !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBody), null, users?.filter((u)=>(0, $6IEar.filterFieldsBySearchValue)([
            u.firstName,
            u.mobile,
            u.lastName,
            u.email,
            u.userStatus
        ], searchValue)).sort((a, b)=>(0, $hBKXa.sortByString)(a[sortFilter.parameter] ?? "", b[sortFilter.parameter] ?? "", sortFilter.reversed)).map((u)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), {
            key: u.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iZaUM.Link), {
            "data-testid": "name-user",
            onClick: ()=>{
                dispatch((0, $7b817a5f2440b094$export$cb57a0abd67769d3)(u));
            },
            to: `/user/${u.id}`,
            className: "pointer table btn-link"
        }, u.firstName, " ", u.lastName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, u.email), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, u.mobile), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": "table-body-cell-status"
        }, u.userStatus === "Valid" ? text("lblValidStatus") : text("lblInvalidStatus")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, u.roleInCompany), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, isAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("button", {
            "data-testid": "remove",
            role: "button",
            className: "btn btn-danger btn-xs margin-left-small btn-icon",
            onClick: ()=>removeUserValue(u.id)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", {
            className: "fa fa-remove"
        })))))))), loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "shimmer-large shimmer-container"
    })));
});





var $6uMv9 = parcelRequire("6uMv9");

var $4vH3e = parcelRequire("4vH3e");

var $akcQ4 = parcelRequire("akcQ4");

var $iZaUM = parcelRequire("iZaUM");
var $84v65 = parcelRequire("84v65");

var $fvmYM = parcelRequire("fvmYM");

var $2naDF = parcelRequire("2naDF");

var $2460e = parcelRequire("2460e");

var $52Dbq = parcelRequire("52Dbq");

var $3YfCm = parcelRequire("3YfCm");

var $aHJk3 = parcelRequire("aHJk3");

var $f7UZA = parcelRequire("f7UZA");

var $1xw2Y = parcelRequire("1xw2Y");

var $aL1Vp = parcelRequire("aL1Vp");
const $d985915eb438d417$var$ButtonContainer = (0, $akcQ4.default).div`
    margin-bottom: 20px;
    justify-content: flex-end;
    display: flex;
    gap: 4px;
`;
const $d985915eb438d417$export$51ad302672431b01 = /*#__PURE__*/ (0, $6uMv9.memo)(function AdminUsersWidget() {
    const text = (0, $aL1Vp.default)();
    const [pools, setPools] = (0, $6uMv9.useState)([]);
    const { id: userId } = (0, $84v65.useParams)();
    const navigate = (0, $iZaUM.useNavigate)();
    const companyId = (0, $4vH3e.useSelector)((state)=>state.user.selectedCompanyId);
    const { data: data, isLoading: loadingInitialData } = (0, $fvmYM.useCompanyGetPoolsWithNfcInfoQuery)({
        companyId: companyId,
        userId: userId
    }, {
        skip: !userId,
        refetchOnMountOrArgChange: true
    });
    const [updateAccess, { isLoading: isLoading }] = (0, $fvmYM.useCompanySetPoolsNfcInfoMutation)();
    (0, $6uMv9.useEffect)(()=>{
        if (data) setPools([
            ...data
        ]);
    }, [
        data
    ]);
    const updateNfcAccess = (pool)=>{
        const newPoolsArray = pools.map((p)=>{
            if (pool.id === p.id) return {
                ...pool,
                hasNfcAccess: !pool.hasNfcAccess
            };
            return p;
        });
        setPools(newPoolsArray);
    };
    const save = async ()=>{
        try {
            await updateAccess({
                userId: userId,
                companyId: companyId,
                body: pools
            }).unwrap();
            (0, $2460e.notifySuccess)(text("lblRFIDAccessToPoolsUpdated"), true);
            navigate(`/user/${userId}`);
        } catch (e) {
            console.error(e);
            (0, $2460e.notifyError)(text("lblSomethingWentWrong"), true);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $52Dbq.PageLayoutContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($d985915eb438d417$var$ButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
        size: "sm",
        label: text("btnSave"),
        onClick: ()=>save(),
        loading: isLoading,
        "data-testid": "btnSave"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
        size: "sm",
        label: text("btnCancel"),
        onClick: ()=>navigate(`/user/${userId}`),
        "data-testid": "btnCancel"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $3YfCm.WidgetLayout), {
        title: text("lblPoolsPage")
    }, userId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.Table), {
        "data-testid": "table-rfid-access"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
        "data-testid": "h-cell-name"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblName"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
        "data-testid": "h-cell-access"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblRFIDAccess"
    })))), !loadingInitialData && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBody), null, pools?.map((p)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), {
            key: p.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": "b-cell-name"
        }, p.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": "b-cell-access"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $aHJk3.Toggle), {
            "data-testid": "pools-toggle",
            isToggled: p.hasNfcAccess ?? false,
            toggleFn: ()=>updateNfcAccess(p)
        })))))), loadingInitialData && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "shimmer-container shimmer-small"
    })));
});





var $6uMv9 = parcelRequire("6uMv9");

var $akcQ4 = parcelRequire("akcQ4");

var $4vH3e = parcelRequire("4vH3e");

var $iZaUM = parcelRequire("iZaUM");
var $84v65 = parcelRequire("84v65");

var $fvmYM = parcelRequire("fvmYM");

var $2naDF = parcelRequire("2naDF");

var $2460e = parcelRequire("2460e");

var $cLivy = parcelRequire("cLivy");

var $52Dbq = parcelRequire("52Dbq");

var $3YfCm = parcelRequire("3YfCm");

var $f7UZA = parcelRequire("f7UZA");

var $aHJk3 = parcelRequire("aHJk3");

var $1xw2Y = parcelRequire("1xw2Y");
parcelRequire("acee3");
var $6IEar = parcelRequire("6IEar");

var $aL1Vp = parcelRequire("aL1Vp");
const $721a58a909e6a690$var$ButtonContainer = (0, $akcQ4.default).div`
    margin-bottom: 20px;
    justify-content: flex-end;
    display: flex;
    gap: 4px;
`;
const $721a58a909e6a690$var$ToggleContainer = (0, $akcQ4.default).span`
    display: flex;
    flex-direction: column;
`;
const $721a58a909e6a690$var$ToggleItem = (0, $akcQ4.default).span`
    display: flex;
    flex-direction: row;
    align-items: center;
`;
const $721a58a909e6a690$export$11c799359c81f5d8 = /*#__PURE__*/ (0, $6uMv9.memo)(function UserChargepointsPage() {
    const text = (0, $aL1Vp.default)();
    const navigate = (0, $iZaUM.useNavigate)();
    const [chargePoints, setChargePoints] = (0, $6uMv9.useState)([]);
    const [changedChargePoints, setChangedChargePoints] = (0, $6uMv9.useState)([]);
    const adaptConnectorNaming = (0, $cLivy.useAdaptConnectorNaming)();
    const { id: userId } = (0, $84v65.useParams)();
    const companyId = (0, $4vH3e.useSelector)((state)=>state.user.selectedCompanyId);
    const [searchValue, setSearchValue] = (0, $6uMv9.useState)("");
    const { data: initialChargePoints, isFetching: isFetching } = (0, $fvmYM.useCompanyGetChargePointsWithNfcInfoQuery)({
        userId: userId,
        companyId: companyId
    }, {
        refetchOnMountOrArgChange: true
    });
    const [updateChargepointsNfcAccess, { isLoading: saving }] = (0, $fvmYM.useCompanySetChargePointsNfcInfoMutation)();
    (0, $6uMv9.useEffect)(()=>{
        if (initialChargePoints) setChargePoints(initialChargePoints);
    }, [
        initialChargePoints
    ]);
    const updateNfcAccess = (chargePointId, connectorId, hasNfcAccess)=>{
        const newChargePointArray = chargePoints.map((c)=>{
            if (c.id === chargePointId) return {
                ...c,
                connectors: c?.connectors?.map((conn)=>{
                    if (conn.connectorId === connectorId) return {
                        ...conn,
                        hasNfcAccess: hasNfcAccess
                    };
                    return conn;
                })
            };
            return c;
        });
        setChargePoints(newChargePointArray);
        let isExisting = false;
        const tempChanged = changedChargePoints.map((c)=>{
            if (c.chargePointId === chargePointId && c.connectorId === connectorId) {
                isExisting = true;
                return {
                    ...c,
                    hasNfcAccess: hasNfcAccess
                };
            }
            return c;
        });
        if (!isExisting) tempChanged.push({
            chargePointId: chargePointId,
            connectorId: connectorId,
            hasNfcAccess: hasNfcAccess
        });
        setChangedChargePoints(tempChanged);
    };
    const save = async ()=>{
        try {
            await updateChargepointsNfcAccess({
                companyId: companyId,
                userId: userId,
                body: changedChargePoints
            }).unwrap();
            (0, $2460e.notifySuccess)(text("lblRFIDAccessToChargersUpdated"), true);
            navigate(`/user/${userId}`);
        } catch (e) {
            console.error(e);
            (0, $2460e.notifyError)(text("lblSomethingWentWrong"), true);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $52Dbq.PageLayoutContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($721a58a909e6a690$var$ButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
        size: "sm",
        label: text("btnSave"),
        "data-testid": "btnSave",
        loading: saving,
        onClick: ()=>save()
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
        size: "sm",
        label: text("btnCancel"),
        onClick: ()=>navigate(`/user/${userId}`),
        "data-testid": "btnCancel"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $3YfCm.WidgetLayout), {
        title: text("btnChargers")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "row margin-bottom-small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "col-xs-12 col-md-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("input", {
        "data-testid": "search",
        type: "text",
        name: "search",
        id: "search",
        className: "form-control",
        value: searchValue,
        onChange: (event)=>setSearchValue(event.target.value),
        placeholder: text("msgSearch")
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.Table), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
        "data-testid": "h-cell-id"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblId"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
        "data-testid": "h-cell-name"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblName"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
        "data-testid": "h-cell-access"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblRFIDAccess"
    })))), !isFetching && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBody), null, chargePoints?.filter((c)=>(0, $6IEar.filterFieldsBySearchValue)([
            c.id,
            c.name ?? ""
        ], searchValue))?.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), {
            key: c.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": "b-cell-id"
        }, c.id), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": "b-cell-name"
        }, c.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": "b-cell-access"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($721a58a909e6a690$var$ToggleContainer, null, c?.connectors?.map((conn)=>{
            if (conn.connectorFunctionType === "Charger") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($721a58a909e6a690$var$ToggleItem, {
                key: conn.connectorId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $aHJk3.default), {
                "data-testid": `connector-toggle-${conn.connectorId}`,
                key: conn.connectorId,
                size: "md",
                isToggled: conn?.hasNfcAccess ?? false,
                toggleFn: ()=>{
                    updateNfcAccess(c.id, conn.connectorId, !conn?.hasNfcAccess);
                }
            }), adaptConnectorNaming(conn.name));
        }))))))), isFetching && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "shimmer-container shimmer-small"
    })));
});





var $6uMv9 = parcelRequire("6uMv9");

var $4vH3e = parcelRequire("4vH3e");

var $akcQ4 = parcelRequire("akcQ4");

var $fvmYM = parcelRequire("fvmYM");

var $2naDF = parcelRequire("2naDF");

var $2460e = parcelRequire("2460e");

var $52Dbq = parcelRequire("52Dbq");

var $3YfCm = parcelRequire("3YfCm");

var $f7UZA = parcelRequire("f7UZA");

var $1xw2Y = parcelRequire("1xw2Y");

var $aL1Vp = parcelRequire("aL1Vp");

var $iZaUM = parcelRequire("iZaUM");
var $84v65 = parcelRequire("84v65");
const $8c535813f07c5508$var$ButtonContainer = (0, $akcQ4.default).div`
    margin-bottom: 20px;
    justify-content: flex-end;
    display: flex;
    gap: 4px;
`;
const $8c535813f07c5508$var$InputContainer = (0, $akcQ4.default).div`
    max-width: 300px;
    margin-bottom: 20px;
`;
const $8c535813f07c5508$export$39bb14b1a5fcc6b8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).memo(function UserNfcTagsPage() {
    const text = (0, $aL1Vp.default)();
    const { id: userId } = (0, $84v65.useParams)();
    const navigate = (0, $iZaUM.useNavigate)();
    const [searchFilter, setSearchFilter] = (0, $6uMv9.useState)("");
    const [buttonLoading, setButtonLoading] = (0, $6uMv9.useState)("");
    const companyId = (0, $4vH3e.useSelector)((state)=>state.user.selectedCompanyId);
    const { data: nfcTags, isLoading: isLoading } = (0, $fvmYM.useCompanyGetNfcTagsQuery)({
        companyId: companyId
    }, {
        refetchOnMountOrArgChange: true
    });
    const [connectNfcToUser] = (0, $fvmYM.useNfcTagConnectToUserMutation)();
    const addToUser = async (tagId)=>{
        setButtonLoading(tagId);
        try {
            await connectNfcToUser({
                nfcTagId: tagId,
                userId: userId
            }).unwrap();
            (0, $2460e.notifySuccess)(text("msgRFIDTagAddedToUser"), true);
            navigate(`/user/${userId}`);
        } catch (e) {
            console.error(e);
            (0, $2460e.notifyError)(text("msgRFIDTagCouldNotBeAdded"), true);
            setButtonLoading("");
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $52Dbq.PageLayoutContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($8c535813f07c5508$var$ButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
        size: "sm",
        label: text("btnCancel"),
        onClick: ()=>navigate(`/user/${userId}`),
        "data-testid": "btnCancel"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $3YfCm.WidgetLayout), {
        title: text("lblRFIDPage")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($8c535813f07c5508$var$InputContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("input", {
        type: "text",
        name: "search",
        id: "search",
        placeholder: text("msgSearch"),
        className: "form-control",
        onChange: (e)=>setSearchFilter(e.target.value)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.Table), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "h-cell-id"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblId"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "h-cell-comment"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblComment"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "h-cell-user"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBody), null, nfcTags?.filter((tag)=>{
        const search = searchFilter.toString().toLocaleLowerCase();
        return tag.id?.toString().toLocaleLowerCase().includes(search) || tag.comment?.toLowerCase()?.includes(search) || tag.firstName?.toLowerCase()?.includes(search) || tag.lastName?.toLowerCase()?.includes(search);
    })?.map((tag)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), {
            key: tag.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": "b-cell-id"
        }, tag?.id), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": "b-cell-comment"
        }, tag?.comment), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": "b-cell-id"
        }, tag?.firstName ? `${tag.firstName} ${tag.lastName}` : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
            size: "sm",
            label: text("btnAddToUser"),
            onClick: ()=>tag.id && addToUser(tag.id),
            loading: buttonLoading === tag.id,
            "data-testid": "add-to-user-btn"
        })))))), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "shimmer-container shimmer-small"
    })));
});





var $174na = parcelRequire("174na");

var $6uMv9 = parcelRequire("6uMv9");

var $4vH3e = parcelRequire("4vH3e");

var $iZaUM = parcelRequire("iZaUM");

var $blgfq = parcelRequire("blgfq");
var $ad8940b6d1cd6bb1$export$edd0ae81c67ebc59;
(function(SortOrders) {
    SortOrders["Ascending"] = "Ascending";
    SortOrders["Descending"] = "Descending";
})($ad8940b6d1cd6bb1$export$edd0ae81c67ebc59 || ($ad8940b6d1cd6bb1$export$edd0ae81c67ebc59 = {}));



var $2460e = parcelRequire("2460e");
const $0a5e8f1202318a24$var$chargePointHasPool = (chargePoint)=>chargePoint.poolId !== "00000000-0000-0000-0000-000000000000" && chargePoint.poolId !== undefined && chargePoint.poolId !== null;
var $0a5e8f1202318a24$export$2e2bcd8739ae039 = $0a5e8f1202318a24$var$chargePointHasPool;



var $jeXdk = parcelRequire("jeXdk");

var $35vY7 = parcelRequire("35vY7");

var $52Dbq = parcelRequire("52Dbq");

var $2naDF = parcelRequire("2naDF");

var $d6sTr = parcelRequire("d6sTr");

var $6uMv9 = parcelRequire("6uMv9");

var $cbVaW = parcelRequire("cbVaW");

var $4vH3e = parcelRequire("4vH3e");

var $fvmYM = parcelRequire("fvmYM");

var $8gLAc = parcelRequire("8gLAc");

var $iktXR = parcelRequire("iktXR");

var $2460e = parcelRequire("2460e");

var $aL1Vp = parcelRequire("aL1Vp");
const $6ff90dae57d12f7e$export$e18ca1ea73bbb286 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).memo(function AddChargePointModal(props) {
    const text = (0, $aL1Vp.default)();
    const { register: register, handleSubmit: handleSubmit, formState: { errors: errors, isValid: isValid } } = (0, $cbVaW.useForm)({
        mode: "onChange",
        delayError: 500
    });
    const companyId = (0, $4vH3e.useSelector)((state)=>state.user.selectedCompanyId);
    const [addChargePoint, { isLoading: isLoading }] = (0, $fvmYM.useCompanyAddChargePointToCompanyMutation)();
    const doAddChargePoint = async (formValues)=>{
        try {
            await addChargePoint({
                companyId: companyId,
                chargePointCredentials: formValues
            }).unwrap();
            props.close();
            (0, $2460e.notifySuccess)(text("lblChargerWasAdded"));
        } catch (e) {
            (0, $2460e.notifyError)(text("msgChargerFailedToAdd"));
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8gLAc.default), {
        title: text("lblChargerAddingModal"),
        "data-testid": "add-chargepoint-modal",
        actions: [
            {
                label: text("btnCancel"),
                callback: props.cancel,
                btn: "btn-secondary"
            },
            {
                label: text("btnSave"),
                callback: handleSubmit(doAddChargePoint),
                disabled: !isValid || isLoading,
                loading: isLoading
            }
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("form", {
        onSubmit: handleSubmit(doAddChargePoint),
        className: "flex flex-column gap-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iktXR.default), {
        id: "id",
        labelText: text("lblSerialNumber"),
        "data-testid": "serial-number-input",
        ...register("id", {
            required: true
        }),
        error: errors.id?.message,
        required: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iktXR.default), {
        id: "wifiPassword",
        "data-testid": "pin-input",
        labelText: text("lblWifiPasswordOrPinCodeField"),
        ...register("wifiPassword", {
            required: true
        }),
        error: errors.wifiPassword?.message,
        required: true
    })));
});



var $aLLzt = parcelRequire("aLLzt");

var $6uMv9 = parcelRequire("6uMv9");

var $2naDF = parcelRequire("2naDF");
const $ebdb1e88c306280d$var$SortedHeader = ({ filter: filter, sortType: sortType, text: text, setSortParams: setSortParams })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("a", {
        onClick: ()=>setSortParams(sortType),
        className: "pointer w-full flex gap-1 justify-content-between align-items-center"
    }, text, filter.parameter && filter?.parameter === sortType && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", {
        className: `fa fa-caret-${filter.reversed ? "up" : "down"}`
    })));
};
var $ebdb1e88c306280d$export$2e2bcd8739ae039 = $ebdb1e88c306280d$var$SortedHeader;


const $bd285a803f2c0c94$export$b108a22f683cb589 = (blobData, name = "data")=>{
    const blob = new Blob([
        blobData
    ], {
        type: "text/csv"
    });
    if (window.navigator && window.navigator.msSaveOrOpenBlob) window.navigator.msSaveBlob(blob, `${name}.csv`);
    else {
        const elem = window.document.createElement("a");
        elem.href = window.URL.createObjectURL(blob);
        elem.download = `${name}.csv`;
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
    }
};



var $3YfCm = parcelRequire("3YfCm");

var $6EtzN = parcelRequire("6EtzN");

var $6GUeO = parcelRequire("6GUeO");

var $fvmYM = parcelRequire("fvmYM");

var $duQ8A = parcelRequire("duQ8A");

var $8sl5H = parcelRequire("8sl5H");

var $6uMv9 = parcelRequire("6uMv9");

var $3Bejm = parcelRequire("3Bejm");
const $04757327247f1981$var$ImportIcon = ({ fill: fill = "currentColor", size: size = 14, title: title, id: id = "info-icon" })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $3Bejm.SIconSpan), {
        title: title,
        id: id,
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: fill ?? "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "feather feather-upload-cloud"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("polyline", {
        points: "16 16 12 12 8 16"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("line", {
        x1: "12",
        y1: "12",
        x2: "12",
        y2: "21"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("path", {
        d: "M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("polyline", {
        points: "16 16 12 12 8 16"
    })));
};
var $04757327247f1981$export$2e2bcd8739ae039 = $04757327247f1981$var$ImportIcon;



var $6uMv9 = parcelRequire("6uMv9");

var $3Bejm = parcelRequire("3Bejm");
const $2497afabdf6e18cc$var$DownloadIcon = ({ fill: fill = "currentColor", size: size = 14, title: title, id: id = "download-icon" })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $3Bejm.SIconSpan), {
        title: title,
        id: id,
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("svg", {
        width: "100%",
        height: "100%",
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("g", {
        clipPath: "url(#clip0_3375_9880)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("path", {
        d: "M11.8 2H10.2V11H11.8V2Z",
        fill: fill
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("path", {
        d: "M11 15.9092C11.856 15.9092 12.656 15.5656 13.264 14.952L18.728 9.36377H16.456L12.128 13.7901C11.832 14.101 11.424 14.2729 11 14.2729C10.576 14.2729 10.168 14.101 9.87197 13.7901L5.54397 9.36377H3.27197L8.73597 14.952C9.34397 15.5656 10.144 15.9092 11 15.9092Z",
        fill: fill
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("path", {
        d: "M19 18.3638H3V20.0001H19V18.3638Z",
        fill: fill
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("clipPath", {
        id: "clip0_3375_9880"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("rect", {
        width: "16",
        height: "18",
        fill: "white",
        transform: "translate(3 2)"
    })))));
};
var $2497afabdf6e18cc$export$2e2bcd8739ae039 = $2497afabdf6e18cc$var$DownloadIcon;



var $iX4Zt = parcelRequire("iX4Zt");

var $dfOhE = parcelRequire("dfOhE");

var $aL1Vp = parcelRequire("aL1Vp");
const $5926fd6dea5d15b9$var$mapSearchParamsToFilter = ({ id: id, imsiNumber: imsiNumber, companyId: companyId, status: status, name: name, ownerEmail: ownerEmail, ownerName: ownerName, ownerMobile: ownerMobile, ocppOnly: ocppOnly, productId: productId })=>{
    return {
        id: id,
        imsiNumber: imsiNumber,
        companyId: companyId,
        status: status,
        name: name,
        ownerEmail: ownerEmail,
        ownerName: ownerName,
        ownerMobile: ownerMobile,
        ocppOnly: ocppOnly,
        productId: productId
    };
};
var $5926fd6dea5d15b9$var$SortParameter;
(function(SortParameter) {
    SortParameter["ID"] = "id";
    SortParameter["NAME"] = "name";
    SortParameter["STATUS"] = "chargePointStatus";
    SortParameter["ORGANISATION"] = "companyName";
    SortParameter["LAST_HEARTBEAT"] = "lastHeartbeat";
    SortParameter["OWNER_NAME"] = "ownerName";
    SortParameter["DESCRIPTION"] = "additionalInfo.description";
    SortParameter["LOADBALANCER_GROUP_NAME"] = "loadBalancerGroupName";
})($5926fd6dea5d15b9$var$SortParameter || ($5926fd6dea5d15b9$var$SortParameter = {}));
const $5926fd6dea5d15b9$export$99edf21a326d7114 = /*#__PURE__*/ (0, $6uMv9.memo)(function AdminChargepointsPage({ className: className, style: style }) {
    const text = (0, $aL1Vp.default)();
    const [chargePointModalOpen, setChargePointModalOpen] = (0, $6uMv9.useState)(false);
    const [currentPage, setCurrentPage] = (0, $6uMv9.useState)(0);
    const [importChargePointModalOpen, setImportChargePointModalOpen] = (0, $6uMv9.useState)(false);
    const [pageSize, setPageSize] = (0, $6uMv9.useState)(20);
    const [sortFilter, setSortFilter] = (0, $6uMv9.useState)({
        parameter: "id",
        reversed: false
    });
    const [searchParams, setParams] = (0, $iZaUM.useSearchParams)();
    const params = Object.fromEntries(searchParams.entries());
    const filter = $5926fd6dea5d15b9$var$mapSearchParamsToFilter(params);
    const { isAdmin: isAdmin, selectedCompanyId: companyId } = (0, $4vH3e.useSelector)((state)=>state.user);
    const { data: chargePoints, error: error, isLoading: isLoading, refetch: refetch } = (0, $fvmYM.useCompanyGetChargePointsPagedQuery)({
        id: filter.id,
        CompanyId: companyId,
        companyId: companyId,
        sortOrder: sortFilter.reversed ? (0, $ad8940b6d1cd6bb1$export$edd0ae81c67ebc59).Descending : (0, $ad8940b6d1cd6bb1$export$edd0ae81c67ebc59).Ascending,
        column: sortFilter.parameter,
        page: currentPage,
        noOfItems: pageSize,
        status: filter.status,
        productId: filter.productId,
        name: filter.name,
        imsiNumber: filter.imsiNumber,
        ownerName: filter.ownerName,
        ownerEmail: filter.ownerEmail,
        ownerMobile: filter.ownerMobile,
        ocppOnly: filter.ocppOnly,
        expand: "additionalInfo,ocppConfig"
    }, {
        refetchOnMountOrArgChange: true
    });
    const [removeChargePointMutation] = (0, $fvmYM.useCompanyRemoveChargePointMutation)();
    const [trigger] = (0, $fvmYM.useLazyCompanyCreateImportStringQuery)();
    (0, $6uMv9.useEffect)(()=>{
        if (error) (0, $2460e.notifyError)(error.data ?? text("msgChargersFailedToFetch"));
    }, [
        error
    ]);
    const downloadImportInfo = async ()=>{
        try {
            (0, $2460e.notifySuccess)(text("msgDownloadImportInformationStarted"));
            const response = await trigger({
                companyId: companyId
            });
            if (!response || !response.data) throw Error;
            (0, $bd285a803f2c0c94$export$b108a22f683cb589)(response.data, text("lblImportDataCSVFile"));
        } catch (e) {
            (0, $2460e.notifyError)(text("msgDownloadImportInformationFailed"));
        }
    };
    const openAddChargePoint = ()=>{
        setChargePointModalOpen(true);
    };
    const openImportChargePoint = ()=>{
        setImportChargePointModalOpen(true);
    };
    const removeChargePoint = async (chargePoint)=>{
        try {
            if (confirm(text("msgConfirmChargerRemoval"))) {
                await removeChargePointMutation({
                    companyId: companyId,
                    chargePointId: chargePoint.id
                }).unwrap();
                refetch();
            }
        } catch (e) {
            (0, $2460e.notifyError)(text("msgChargerFailedToRemove"));
        }
    };
    const saveAndClose = ()=>{
        (0, $2460e.notifySuccess)(text("lblChargerWasAdded"));
        refetch();
        setChargePointModalOpen(false);
    };
    const applySortFilter = (sortParamName)=>{
        setSortFilter({
            parameter: sortParamName,
            reversed: sortFilter.parameter === sortParamName ? !sortFilter?.reversed : false
        });
    };
    const filterSubmit = (filter)=>{
        setParams((0, $blgfq.pickBy)(filter, (value)=>value !== undefined && value !== null));
        if (currentPage !== 0) setCurrentPage(0);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $52Dbq.PageLayoutContainer), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($174na)))(className),
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $3YfCm.WidgetLayout), {
        "data-testid": "table-charge-points",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($174na)))("flex-1", className),
        style: style,
        headerButtons: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $6EtzN.ChargePointsSearchWidget), {
            onSubmit: filterSubmit,
            filter: filter
        }),
        contextMenuItems: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $duQ8A.DropdownMenuItem), {
            onClick: ()=>openAddChargePoint(),
            text: text("btnAddCharger"),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8sl5H.default), null),
            key: "btnAddCharger",
            "data-testid": "open-add-chargepoints-btn"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $duQ8A.DropdownMenuItem), {
            onClick: ()=>openImportChargePoint(),
            text: text("lblChargersImportModal"),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $04757327247f1981$export$2e2bcd8739ae039), null),
            key: "btnImportChargers",
            "data-testid": "open-import-chargepoints-btn"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $duQ8A.DropdownMenuItem), {
            onClick: ()=>downloadImportInfo(),
            text: text("msgDownloadImportInformation"),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2497afabdf6e18cc$export$2e2bcd8739ae039), null),
            key: "btnDownloadImportInformation",
            "data-testid": "open-download-import-info-btn"
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $6GUeO.default), {
        amount: chargePoints?.totalCount,
        isLoading: isLoading,
        pageSize: pageSize,
        setCurrentPage: setCurrentPage,
        setPageSize: setPageSize
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.Table), {
        className: "flex-1",
        isLoading: isLoading,
        "data-testid": "chargepoints-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $ebdb1e88c306280d$export$2e2bcd8739ae039), {
        filter: sortFilter,
        sortType: "id",
        text: text("lblSerialNumberShort"),
        setSortParams: ()=>{
            applySortFilter("id");
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $ebdb1e88c306280d$export$2e2bcd8739ae039), {
        filter: sortFilter,
        sortType: "chargePointStatus",
        text: text("lblStatus"),
        setSortParams: ()=>{
            applySortFilter("chargePointStatus");
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        className: "heading5"
    }, text("lblSettings")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $ebdb1e88c306280d$export$2e2bcd8739ae039), {
        filter: sortFilter,
        sortType: "lastHeartbeat",
        text: text("lblOffline"),
        setSortParams: ()=>{
            applySortFilter("lastHeartbeat");
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $ebdb1e88c306280d$export$2e2bcd8739ae039), {
        filter: sortFilter,
        sortType: "name",
        text: text("lblName"),
        setSortParams: ()=>{
            applySortFilter("name");
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $ebdb1e88c306280d$export$2e2bcd8739ae039), {
        filter: sortFilter,
        sortType: "ownerName",
        text: text("lblUserOrOwner"),
        setSortParams: ()=>{
            applySortFilter("ownerName");
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $ebdb1e88c306280d$export$2e2bcd8739ae039), {
        filter: sortFilter,
        sortType: "additionalInfo.description",
        text: text("lblDescription"),
        setSortParams: ()=>{
            applySortFilter("additionalInfo.description");
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $ebdb1e88c306280d$export$2e2bcd8739ae039), {
        filter: sortFilter,
        sortType: "loadBalancerGroupName",
        text: text("lblLoadBalancer"),
        setSortParams: ()=>{
            applySortFilter("loadBalancerGroupName");
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        className: "heading5 hidden-xs hidden-sm"
    }, text("lblPool")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        className: "heading5"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBody), {
        isLoading: isLoading,
        numberOfLoadingColumns: 9
    }, chargePoints && chargePoints.items?.map((chargePoint)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), {
            key: chargePoint.id,
            "data-testid": `chargepoint-${chargePoint.id}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iZaUM.Link), {
            className: "table btn-link",
            to: `/chargepoints/${chargePoint.id}`
        }, chargePoint.id)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $jeXdk.ChargepointStatus), {
            chargePoint: chargePoint
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, (0, $d6sTr.default)({
            chargePoint: chargePoint
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, chargePoint.chargePointStatus == "Offline" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", null, (0, $dfOhE.default)(chargePoint.isOcpp ? chargePoint.offlineSince : chargePoint.lastHeartbeat))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, chargePoint.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            className: "hidden-xs hidden-sm"
        }, (0, $iX4Zt.getOwner)(chargePoint)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            className: "hidden-xs hidden-sm"
        }, chargePoint.additionalInfo?.description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            className: "hidden-xs hidden-sm"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iZaUM.Link), {
            to: `/loadbalancer/${chargePoint.loadBalancerGroupId}`
        }, chargePoint.loadBalancerGroupName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            className: "hidden-xs hidden-sm"
        }, (0, $0a5e8f1202318a24$export$2e2bcd8739ae039)(chargePoint) && chargePoint.poolName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, isAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("button", {
            type: "button",
            "data-toggle": "tooltip",
            "data-placement": "top",
            title: text("btnRemoveWithLBNote"),
            onClick: ()=>removeChargePoint(chargePoint),
            className: "btn btn-danger btn-xs btn-icon",
            disabled: !!chargePoint.loadBalancerGroupId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", {
            className: "fa fa-remove"
        }))))))), !isLoading && chargePoints && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $35vY7.ChargersPagination), {
        totalCount: chargePoints?.totalCount ?? 0,
        pageIndex: filter?.page ?? 0,
        setPageIndex: setCurrentPage,
        pageSize: chargePoints?.pageSize ?? 0,
        displayedChargers: chargePoints?.items?.length ?? 0
    }))), chargePointModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $6ff90dae57d12f7e$export$e18ca1ea73bbb286), {
        close: saveAndClose,
        cancel: ()=>setChargePointModalOpen(false)
    }), importChargePointModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $aLLzt.ImportChargePointModal), {
        close: ()=>{
            setImportChargePointModalOpen(false);
            (0, $2460e.notifySuccess)(text("lblChargerWasAdded"));
            refetch();
        },
        cancel: ()=>setImportChargePointModalOpen(false)
    }));
});





var $6uMv9 = parcelRequire("6uMv9");

var $174na = parcelRequire("174na");

var $52Dbq = parcelRequire("52Dbq");

var $6uMv9 = parcelRequire("6uMv9");

var $174na = parcelRequire("174na");

var $akcQ4 = parcelRequire("akcQ4");

var $cbVaW = parcelRequire("cbVaW");

var $4vH3e = parcelRequire("4vH3e");

var $1xw2Y = parcelRequire("1xw2Y");

var $3YfCm = parcelRequire("3YfCm");

var $2llRK = parcelRequire("2llRK");

var $iFhrk = parcelRequire("iFhrk");

var $fvmYM = parcelRequire("fvmYM");

var $2460e = parcelRequire("2460e");

var $iktXR = parcelRequire("iktXR");

var $f7UZA = parcelRequire("f7UZA");

var $bN3Nf = parcelRequire("bN3Nf");

var $aL1Vp = parcelRequire("aL1Vp");

var $aN41L = parcelRequire("aN41L");
const $cbc9ed0472482dc7$var$SFormsGroups = (0, $akcQ4.default).form`
    display: flex;
    flex-wrap: wrap;
    gap: 35px;
`;
const $cbc9ed0472482dc7$var$SFormGroup = (0, $akcQ4.default).div`
    display: flex;
    flex-direction: column;
    gap: 15px;
    flex-grow: 1;
`;
const $cbc9ed0472482dc7$var$SActions = (0, $akcQ4.default).div`
    margin: auto 0 0 auto;
`;
const $cbc9ed0472482dc7$var$SCheckboxForm = (0, $akcQ4.default).div`
    display: flex;
    align-items: center;
    gap: 4px;
`;
const $cbc9ed0472482dc7$var$InlineLabelWithCheckBox = (0, $akcQ4.default).label`
    margin-top: 4px;
    margin-bottom: 0px;
`;
const $cbc9ed0472482dc7$export$b01a4f246294af07 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).memo(function OrganizationSettingsWidget({ className: className, style: style }) {
    const text = (0, $aL1Vp.default)();
    const companyId = (0, $4vH3e.useSelector)((state)=>state.user.selectedCompanyId);
    const user = (0, $4vH3e.useSelector)((state)=>state.user);
    const [updateCompany, { isLoading: isSaving }] = (0, $fvmYM.useCompanyUpdateCompanyMutation)();
    const { data: company, isLoading: isLoading, refetch: refetch } = (0, $fvmYM.useCompanyGetCompanyByIdQuery)({
        companyId: companyId
    });
    const { register: register, handleSubmit: handleSubmit, reset: reset, formState: { errors: errors, isValid: isValid, isDirty: isDirty } } = (0, $cbVaW.useForm)({
        defaultValues: {
            name: company?.name ?? "",
            phone: company?.phone ?? "",
            contactPerson: company?.contactPerson ?? "",
            address1: company?.address1 ?? "",
            address2: company?.address2 ?? "",
            kWhPrice: company?.kWhPrice ?? 0,
            comment: company?.comment ?? "",
            description: company?.description ?? "",
            ownerReadOnly: company?.ownerReadOnly ?? false,
            email: company?.email ?? ""
        },
        mode: "onChange",
        delayError: 500
    });
    (0, $6uMv9.useEffect)(()=>{
        reset(company);
    }, [
        company
    ]);
    const saveCompany = async (company)=>{
        try {
            await updateCompany({
                company: {
                    ...company
                }
            }).unwrap();
            refetch();
            (0, $2460e.notifySuccess)(text("msgCompanyUpdated"));
        } catch (error) {
            (0, $2460e.notifyError)(text("msgCompanyNotUpdated"));
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $3YfCm.WidgetLayout), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($174na)))(className),
        style: style,
        title: text("lblOrganisationSettingsPage"),
        loadingStatus: isLoading,
        "data-testid": "org-settings-widget"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($cbc9ed0472482dc7$var$SFormsGroups, {
        noValidate: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($cbc9ed0472482dc7$var$SFormGroup, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("label", {
        htmlFor: "name",
        "data-testid": "name"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblNameField"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iktXR.default), {
        "data-testid": "name-input",
        id: "name",
        ...register("name", {
            required: {
                value: true,
                message: text("msgNameRequired")
            }
        }),
        error: errors && errors.name?.message,
        maxLength: (0, $aN41L.MAX_NAME_LENGTH),
        required: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("label", {
        htmlFor: "phone",
        "data-testid": "phone"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblPhoneField"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iktXR.default), {
        id: "phone",
        ...register("phone"),
        maxLength: (0, $aN41L.MAX_ORG_PHONE_NO_LENGTH)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("label", {
        htmlFor: "contactPerson",
        "data-testid": "contactPerson"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblContactPersonField"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iktXR.default), {
        id: "contactPerson",
        ...register("contactPerson"),
        maxLength: (0, $aN41L.MAX_ORG_CONTACT_PERSON_LENGTH)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("label", {
        htmlFor: "price",
        "data-testid": "kWhPrice"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblPricePerKWhField"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iktXR.default), {
        id: "price",
        type: "number",
        ...register("kWhPrice")
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("label", {
        htmlFor: "comment",
        "data-testid": "comment"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblCommentField"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $bN3Nf.default), {
        id: "comment",
        rows: 5,
        cols: 5,
        ...register("comment"),
        maxLength: (0, $aN41L.MAX_ORG_COMMENT_LENGTH)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($cbc9ed0472482dc7$var$SFormGroup, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("label", {
        htmlFor: "description",
        "data-testid": "description"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblDescriptionField"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iktXR.default), {
        id: "description",
        "data-testid": "description-input",
        ...register("description", {
            required: {
                value: true,
                message: text("msgDescriptionRequired")
            }
        }),
        error: errors && errors.description?.message,
        maxLength: (0, $aN41L.MAX_ORG_DESC_LENGTH),
        required: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("label", {
        htmlFor: "email",
        "data-testid": "email"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblEmailField"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iktXR.default), {
        type: "email",
        id: "email",
        ...register("email"),
        maxLength: (0, $aN41L.MAX_ORG_EMAIL_LENGTH)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("label", {
        htmlFor: "address1",
        "data-testid": "address1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblAddressLineOneField"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iktXR.default), {
        id: "address1",
        ...register("address1"),
        maxLength: (0, $aN41L.MAX_ORG_ADDRESS_1_LENGTH)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("label", {
        htmlFor: "address2",
        "data-testid": "address2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblAddressLineTwoField"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iktXR.default), {
        id: "address2",
        ...register("address2"),
        maxLength: (0, $aN41L.MAX_ORG_ADDRESS_2_LENGTH)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("h5", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblReadOnlyAccess"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblReadOnlyAccessDescription"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($cbc9ed0472482dc7$var$SCheckboxForm, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("input", {
        type: "checkbox",
        className: "checkbox-black",
        ...register("ownerReadOnly")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($cbc9ed0472482dc7$var$InlineLabelWithCheckBox, {
        htmlFor: "ownerReadOnly",
        "data-testid": "ownerReadOnly"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("h5", null, text("lblActivateReadOnlyAccess"))))), (0, $2llRK.default)(user, companyId || "", (0, $iFhrk.default).Admin) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($cbc9ed0472482dc7$var$SActions, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
        "data-testid": "save-btn",
        type: "submit",
        disabled: isLoading || isSaving || !isValid || !isDirty,
        onClick: handleSubmit(saveCompany),
        label: text("btnSave")
    })))));
});




const $52f08e8cd1183bb7$export$8f6dcfe950367406 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).memo(function SettingsPage({ className: className, style: style }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $52Dbq.PageLayoutContainer), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($174na)))(className),
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cbc9ed0472482dc7$export$b01a4f246294af07), null));
});





var $6uMv9 = parcelRequire("6uMv9");

var $4vH3e = parcelRequire("4vH3e");

var $akcQ4 = parcelRequire("akcQ4");

var $84v65 = parcelRequire("84v65");

var $fvmYM = parcelRequire("fvmYM");

var $2460e = parcelRequire("2460e");

var $6uMv9 = parcelRequire("6uMv9");

var $174na = parcelRequire("174na");

var $iZaUM = parcelRequire("iZaUM");
var $84v65 = parcelRequire("84v65");

var $3YfCm = parcelRequire("3YfCm");

var $2naDF = parcelRequire("2naDF");

var $1xw2Y = parcelRequire("1xw2Y");

var $k0EDO = parcelRequire("k0EDO");

var $bHaiB = parcelRequire("bHaiB");
const $20e2a118a44f5a5d$export$a71ecc24683233d6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).memo(function AdminUserAccessToChargersWidget({ chargePoints: chargePoints, isAdmin: isAdmin, dataLoadingChargePoints: dataLoadingChargePoints, style: style }) {
    const { id: userId } = (0, $84v65.useParams)();
    const navigate = (0, $iZaUM.useNavigate)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $3YfCm.WidgetLayout), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
            code: "lblRFIDAccessToChargers"
        }),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($174na)))({
            widgetprocessing: dataLoadingChargePoints
        }),
        headerButtons: [
            isAdmin ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $k0EDO.Button), {
                code: "btnEdit",
                small: true,
                onClick: ()=>navigate(`/user/${userId}/userChargePoints`),
                dataTestId: "btn-edit"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).Fragment, null)
        ],
        "data-testid": "access-chargers"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.Table), {
        "data-testid": "access-chargers-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "lbl-id"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblId"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "lbl-name"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblName"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "lbl-sockets"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblSockets"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBody), null, chargePoints?.map((chargePoint)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), {
            key: chargePoint.id,
            "data-testid": `row-${chargePoint.id}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iZaUM.Link), {
            className: "btn-link",
            to: `/chargepoints/${chargePoint.id}`,
            "data-testid": "btn-link"
        }, chargePoint.id)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": `name-${chargePoint.id}`
        }, chargePoint.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": `socket-${chargePoint.id}`
        }, !(0, $bHaiB.default)(chargePoint) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", {
            className: "fa fa-circle"
        }), (0, $bHaiB.default)(chargePoint) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", null, chargePoint.connectors?.map((connector)=>connector.hasNfcAccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", {
                key: connector.connectorId,
                "data-testid": "users-has-nfc-access",
                className: "fa fa-circle margin-right-2"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", {
                key: connector.connectorId,
                "data-testid": "users-has-no-nfc-access",
                className: "fa fa-circle-o"
            }))))))))));
});





var $6uMv9 = parcelRequire("6uMv9");

var $iZaUM = parcelRequire("iZaUM");

var $1xw2Y = parcelRequire("1xw2Y");

var $2naDF = parcelRequire("2naDF");

var $dXUkh = parcelRequire("dXUkh");

var $3YfCm = parcelRequire("3YfCm");
function $1898cefe68d6ec2b$export$72eeb2e143f5b912({ style: style, registeredChargePoints: registeredChargePoints, dataLoadingOwnedChargePoints: dataLoadingOwnedChargePoints }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $3YfCm.WidgetLayout), {
        loadingStatus: dataLoadingOwnedChargePoints,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
            code: "lblRegisteredToChargers"
        }),
        style: style,
        "data-testid": "registered-to-chargers"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.Table), {
        "data-testid": "registered-chargers"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "lbl-id"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblId"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "lbl-name"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblName"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBody), null, registeredChargePoints?.map((c, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), {
            key: i,
            "data-testid": `row-${i}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": `charger-id-${i}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dXUkh.STableLink), {
            as: (0, $iZaUM.Link),
            to: `/chargepoints/${c.id}`
        }, c.id)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": `charger-name-${i}`
        }, c.name))))));
}





var $6uMv9 = parcelRequire("6uMv9");

var $174na = parcelRequire("174na");

var $iZaUM = parcelRequire("iZaUM");

var $3YfCm = parcelRequire("3YfCm");

var $2naDF = parcelRequire("2naDF");

var $1xw2Y = parcelRequire("1xw2Y");

var $k0EDO = parcelRequire("k0EDO");
const $291a3ae24285c4d8$export$3dcba8e413d97468 = /*#__PURE__*/ (0, $6uMv9.memo)(function AdminUserAccessToPoolsWidget({ pools: pools, style: style, isAdmin: isAdmin, dataloadingPools: dataloadingPools, disableEdit: disableEdit, userId: userId }) {
    const navigate = (0, $iZaUM.useNavigate)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $3YfCm.WidgetLayout), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
            code: "lblRFIDAccessToPools"
        }),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($174na)))({
            widgetprocessing: dataloadingPools
        }),
        headerButtons: [
            isAdmin ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $k0EDO.Button), {
                disabled: disableEdit,
                code: "btnEdit",
                small: true,
                onClick: ()=>navigate(`/user/${userId}/userPools`),
                dataTestId: "btn-edit"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).Fragment, null)
        ],
        "data-testid": "access-pools"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.Table), {
        "data-testid": "access-pools-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "lbl-name"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblName"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBody), null, pools?.map((pool)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), {
            key: pool.id,
            "data-testid": "name"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, pool.name)))))));
});





var $6uMv9 = parcelRequire("6uMv9");

var $akcQ4 = parcelRequire("akcQ4");

var $iZaUM = parcelRequire("iZaUM");
var $84v65 = parcelRequire("84v65");

var $3YfCm = parcelRequire("3YfCm");

var $2naDF = parcelRequire("2naDF");

var $1xw2Y = parcelRequire("1xw2Y");

var $6uMv9 = parcelRequire("6uMv9");

var $akcQ4 = parcelRequire("akcQ4");

var $iZaUM = parcelRequire("iZaUM");

var $8MU0a = parcelRequire("8MU0a");

var $aL1Vp = parcelRequire("aL1Vp");

var $1xw2Y = parcelRequire("1xw2Y");

var $8gLAc = parcelRequire("8gLAc");
const $7dcac2369e7a770a$var$MAX_LENGTH = 40;
const $7dcac2369e7a770a$var$SelectedContainer = (0, $akcQ4.default).div`
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
`;
const $7dcac2369e7a770a$var$EditNFCGroupModal = ({ close: close, dismiss: dismiss, nfcTags: nfcTags })=>{
    const text = (0, $aL1Vp.default)();
    const [clearComment, setClearComment] = (0, $6uMv9.useState)(false);
    const [clearExternalId, setClearExternalId] = (0, $6uMv9.useState)(false);
    const [rfidTags, setRfidTags] = (0, $6uMv9.useState)(nfcTags);
    const [comment, setComment] = (0, $6uMv9.useState)("");
    const [externalId, setExternalId] = (0, $6uMv9.useState)("");
    const placeholder = (value, clearFlag)=>{
        if (clearFlag) return text("msgValueWillBeCleared");
        if (typeof value === "undefined") return text("msgKeepWithoutChanges");
        return text("msgClearTheValue");
    };
    const onInputExternalId = (event)=>{
        const newExternalId = event.target.value;
        setExternalId(newExternalId);
    };
    const toggleSelect = (rfidTag)=>{
        if (rfidTags.includes(rfidTag)) setRfidTags(rfidTags.filter((tag)=>tag.id !== rfidTag.id));
        else setRfidTags([
            ...rfidTags,
            rfidTag
        ]);
    };
    const toggleSelectAll = ()=>{
        if (rfidTags.length === nfcTags.length) setRfidTags([]);
        else setRfidTags(nfcTags);
    };
    const save = ()=>{
        close(rfidTags.map((tag)=>({
                ...tag,
                comment: clearComment || comment.length ? comment : tag.comment,
                externalId: clearExternalId || externalId.length ? externalId : tag.externalId
            })));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8gLAc.default), {
        size: "sm",
        title: text("lblEditRFIDGroupModal"),
        actions: [
            {
                label: text("btnSave"),
                callback: ()=>save(),
                disabled: !rfidTags.length
            },
            {
                label: text("btnCancel"),
                callback: ()=>dismiss()
            }
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("form", {
        onSubmit: (0, $8MU0a.default)(save)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "modal-body"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("label", {
        style: {
            display: "block"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "msgSelectRFIDToEdit"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iZaUM.Link), {
        to: "/",
        onClick: (0, $8MU0a.default)(toggleSelectAll),
        className: "pull-right"
    }, nfcTags.length === rfidTags.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "btnUnselectAll"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "btnSelectAll"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($7dcac2369e7a770a$var$SelectedContainer, null, nfcTags.map((nfcTag)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", {
            className: "checkbox-form",
            key: nfcTag.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("input", {
            className: "checkbox-black",
            type: "checkbox",
            checked: rfidTags.includes(nfcTag),
            onChange: ()=>toggleSelect(nfcTag)
        }), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", null, nfcTag.id))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("label", {
        className: "pull-right text-lowercase checkbox-form"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("input", {
        className: "checkbox-black",
        type: "checkbox",
        checked: clearComment,
        onChange: ()=>{
            setClearComment(!clearComment);
            setComment("");
        }
    }), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "btnClear"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("label", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblCommentField"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("input", {
        type: "text",
        className: "form-control",
        placeholder: placeholder(comment, clearComment),
        disabled: clearComment,
        value: comment,
        onChange: (e)=>setComment(e.target.value)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("label", {
        className: "pull-right text-lowercase checkbox-form"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("input", {
        className: "checkbox-black",
        type: "checkbox",
        checked: clearExternalId,
        onChange: ()=>setClearExternalId(!clearExternalId)
    }), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "btnClear"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("label", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblExternalIdField"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("input", {
        type: "text",
        className: "form-control",
        placeholder: placeholder(externalId, clearExternalId),
        disabled: clearExternalId,
        value: externalId,
        onChange: onInputExternalId,
        maxLength: $7dcac2369e7a770a$var$MAX_LENGTH
    })))));
};
var $7dcac2369e7a770a$export$2e2bcd8739ae039 = $7dcac2369e7a770a$var$EditNFCGroupModal;



var $f7UZA = parcelRequire("f7UZA");

var $aL1Vp = parcelRequire("aL1Vp");

var $i4kGB = parcelRequire("i4kGB");
const $b46f809c3d3a32ad$var$RfidTable = (0, $akcQ4.default).div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;
const $b46f809c3d3a32ad$export$dca7950e5ef74285 = /*#__PURE__*/ (0, $6uMv9.memo)(function AdminUserRfidTagsWidget({ nfcTags: nfcTags, isAdmin: isAdmin, editNfcTagsGroup: editNfcTagsGroup, deleteNfcTagFromUser: deleteNfcTagFromUser, style: style }) {
    const text = (0, $aL1Vp.default)();
    const navigate = (0, $iZaUM.useNavigate)();
    const { id: userId } = (0, $84v65.useParams)();
    const [showModal, setShowModal] = (0, $6uMv9.useState)(false);
    const [editTag, setEditTag] = (0, $6uMv9.useState)(null);
    const renderWidgetHeaderButtons = ()=>{
        return [
            isAdmin && nfcTags.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
                label: text("btnEditGroup"),
                size: "sm",
                className: "margin-right-small",
                onClick: ()=>setShowModal(true),
                "data-testid": "btn-edit"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).Fragment, null),
            isAdmin ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
                label: text("btnAdd"),
                size: "sm",
                onClick: ()=>navigate(`/user/${userId}/userNfcTags`),
                "data-testid": "btn-add"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).Fragment, null)
        ];
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $3YfCm.WidgetLayout), {
        title: text("lblRFIDWidget"),
        headerButtons: renderWidgetHeaderButtons(),
        "data-testid": "rfid-tags"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.Table), {
        "data-testid": "rfid-tags-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "lbl-id"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblId"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "lbl-comment"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblComment"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBody), null, nfcTags?.map((nfctag)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), {
            key: nfctag.id,
            "data-testid": `row-${nfctag.id}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($b46f809c3d3a32ad$var$RfidTable, {
            "data-testid": `id-${nfctag.id}`
        }, nfctag.id, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
            code: "lblExternalId"
        }), ":", " ", nfctag.externalId ? nfctag.externalId : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
            code: "msgValueNotSet"
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
            "data-testid": `commet-${nfctag.id}`
        }, nfctag.comment), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, isAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("button", {
            type: "button",
            onClick: ()=>deleteNfcTagFromUser(nfctag),
            className: "btn btn-danger btn-xs pull-right btn-icon",
            "data-testid": "btn-delete"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", {
            "data-testid": "remove-icon",
            className: "fa fa-remove"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("button", {
            type: "button",
            onClick: ()=>setEditTag(nfctag),
            className: "btn btn-ok btn-xs pull-right btn-icon  margin-right-xsmall",
            "data-testid": "btn-edit"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", {
            "data-testid": "edit-icon",
            className: "fa fa-edit"
        }))))))))), showModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $7dcac2369e7a770a$export$2e2bcd8739ae039), {
        nfcTags: nfcTags,
        dismiss: ()=>setShowModal(false),
        close: (tags)=>{
            editNfcTagsGroup(tags);
            setShowModal(false);
        }
    }), editTag ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $i4kGB.RfidTagModal), {
        rfidTag: editTag,
        onClose: ()=>setEditTag(null)
    }) : null);
});





var $52Dbq = parcelRequire("52Dbq");

parcelRequire("bOBEI");
var $77EIr = parcelRequire("77EIr");

var $2llRK = parcelRequire("2llRK");

var $6uMv9 = parcelRequire("6uMv9");

var $4vH3e = parcelRequire("4vH3e");

var $iZaUM = parcelRequire("iZaUM");

var $3YfCm = parcelRequire("3YfCm");

var $1xw2Y = parcelRequire("1xw2Y");

var $2llRK = parcelRequire("2llRK");

var $iFhrk = parcelRequire("iFhrk");

var $f7UZA = parcelRequire("f7UZA");

var $fvmYM = parcelRequire("fvmYM");

var $iCWiW = parcelRequire("iCWiW");

var $2460e = parcelRequire("2460e");

var $9AhwP = parcelRequire("9AhwP");

var $aL1Vp = parcelRequire("aL1Vp");

var $akcQ4 = parcelRequire("akcQ4");
const $7315afaaa98651b1$export$a7fed597f4b8afd8 = (0, $akcQ4.default).form`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;
const $7315afaaa98651b1$export$b59bdbef9ce70de2 = (0, $akcQ4.default).div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;
const $7315afaaa98651b1$export$816b5d811295e6bc = (0, $akcQ4.default).div`
    display: flex;
    flex-direction: column;
    gap: 6px;
`;
const $7315afaaa98651b1$export$9ba90c23173739d1 = (0, $akcQ4.default).div`
    font-weight: 500;
    display: flex;
    flex-direction: row;
    gap: 4px;
    align-items: flex-end;
`;



var $6uMv9 = parcelRequire("6uMv9");

var $1xw2Y = parcelRequire("1xw2Y");

const $41f551e2ab6e2077$var$UserDetailsPassword = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).memo(function UserDetailsPassword({ onChange: onChange, openPasswordChange: openPasswordChange, setOpenPasswordChange: setOpenPasswordChange }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $7315afaaa98651b1$export$9ba90c23173739d1), {
        className: "pointer",
        onClick: ()=>setOpenPasswordChange(),
        "data-testid": "change-password"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblChangingPassword"
    }), !openPasswordChange && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", {
        className: "fa fa-caret-right"
    }), openPasswordChange && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", {
        className: "fa fa-caret-down"
    })), openPasswordChange && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $7315afaaa98651b1$export$b59bdbef9ce70de2), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $7315afaaa98651b1$export$816b5d811295e6bc), {
        "data-testid": "newPassword"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblPasswordField"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("input", {
        className: "form-control",
        id: "newPassword",
        type: "password",
        "data-testid": "newPassword-input"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $7315afaaa98651b1$export$816b5d811295e6bc), {
        "data-testid": "passwordCompare"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblConfirmPasswordField"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("input", {
        className: "form-control",
        onChange: (e)=>onChange(e.target.value),
        type: "password",
        "data-testid": "passcordCompare-input"
    }))));
});
var $41f551e2ab6e2077$export$2e2bcd8739ae039 = $41f551e2ab6e2077$var$UserDetailsPassword;


const $e183e03c39851310$var$UserDetails = /*#__PURE__*/ (0, $6uMv9.memo)(function UserDetails() {
    const text = (0, $aL1Vp.default)();
    const navigate = (0, $iZaUM.useNavigate)();
    const signedInUser = (0, $4vH3e.useSelector)((state)=>state.user);
    const user = (0, $4vH3e.useSelector)((state)=>state.selectedUser);
    const [selectedUser, setSelectedUser] = (0, $6uMv9.useState)(user);
    const [openPasswordChange, setOpenPasswordChange] = (0, $6uMv9.useState)(false);
    const checkPassword = (password, passwordCompare)=>{
        if (password !== passwordCompare) return text("msgPasswordDoNotMatch");
        if (password && password.length < 8) return text("msgPasswordToShort");
        return null;
    };
    const isAdmin = ()=>{
        return (0, $2llRK.default)(signedInUser, signedInUser.selectedCompanyId, (0, $iFhrk.default).Admin);
    };
    const showChangePassword = ()=>{
        return (0, $iCWiW.default)(signedInUser, selectedUser) || isAdmin() && selectedUser.passwordChangeableForAdmin;
    };
    const closeChangePassword = ()=>{
        if (openPasswordChange) setSelectedUser({
            ...selectedUser,
            passwordChange: null
        });
        setOpenPasswordChange(!openPasswordChange);
    };
    (0, $6uMv9.useEffect)(()=>{
        setSelectedUser(user);
    }, [
        user
    ]);
    const disableSave = ()=>{
        if (!user.id) return !selectedUser.firstName || !selectedUser.lastName || !selectedUser.email || !selectedUser.password || !selectedUser.roleInCompany;
        if (openPasswordChange) return !selectedUser.firstName || !selectedUser.lastName || !selectedUser.email || !selectedUser.passwordChange?.newPassword;
        return !selectedUser.firstName || !selectedUser.lastName || !selectedUser.email || updatingUser || updatingRole || creatingUser || invitingUser || addingRole;
    };
    const [updateUser, { isLoading: updatingUser }] = (0, $fvmYM.useCompanyUpdateUserMutation)();
    const [updateRole, { isLoading: updatingRole }] = (0, $fvmYM.useCompanyUpdateRoleToUserMutation)();
    const [createUser, { isLoading: creatingUser }] = (0, $fvmYM.useCompanyCreateUserMutation)();
    const [inviteUser, { isLoading: invitingUser }] = (0, $fvmYM.useCompanyInviteExistingUserToCompanyMutation)();
    const [addRole, { isLoading: addingRole }] = (0, $fvmYM.useCompanyAddRoleToUserMutation)();
    const save = async (e)=>{
        e?.preventDefault();
        if (selectedUser.id) try {
            if (openPasswordChange) {
                const { newPassword: newPassword } = e?.currentTarget.elements;
                const error = checkPassword(selectedUser.passwordChange?.newPassword, newPassword?.value);
                if (error) {
                    (0, $2460e.notifyError)(error, false);
                    return;
                }
            }
            await updateUser({
                companyId: signedInUser.selectedCompanyId,
                chargePointUser: selectedUser
            }).unwrap();
            const role = {
                claim: selectedUser.roleInCompany,
                companyId: signedInUser.selectedCompanyId,
                chargePointUserId: selectedUser.id
            };
            await updateRole({
                companyId: signedInUser.selectedCompanyId,
                userId: selectedUser.id,
                role: role
            }).unwrap();
            (0, $2460e.notifySuccess)(text(openPasswordChange ? "msgProfilePasswordUpdated" : "msgUserUpdated"), true);
        } catch (e) {
            (0, $2460e.notifyError)(text("msgUserNotSaved"), true);
            console.error(e);
        }
        else {
            const { passwordCompare1: passwordCompare1 } = e?.currentTarget.elements;
            const error = checkPassword(selectedUser.password, passwordCompare1?.value);
            if (error) {
                (0, $2460e.notifyError)(error, false);
                return;
            }
            try {
                selectedUser.userStatus = "Valid";
                const res = await createUser({
                    companyId: signedInUser.selectedCompanyId,
                    chargePointUser: selectedUser
                }).unwrap();
                const role = {
                    claim: selectedUser.roleInCompany,
                    companyId: signedInUser.selectedCompanyId,
                    chargePointUserId: res.id
                };
                await addRole({
                    companyId: signedInUser.selectedCompanyId,
                    userId: res.id ?? "",
                    role: role
                }).unwrap();
                navigate("/users");
                (0, $2460e.notifySuccess)(text("lblNewUsercreated"), true);
            } catch (e) {
                if (e.status === 412) (0, $2460e.notifyError)(text("msgUserAlreadyInOrg"), true);
                else if (e.status === 409) {
                    if (confirm(text("msgShouldSendInviteToExistingUser"))) try {
                        await inviteUser({
                            companyId: signedInUser.selectedCompanyId,
                            chargePointUser: selectedUser,
                            role: selectedUser.roleInCompany ?? ""
                        }).unwrap();
                        (0, $2460e.notifySuccess)(text("msgInviteSent"), true);
                        navigate("/users");
                    } catch (e) {
                        (0, $2460e.notifyError)(text("msgInviteNotSent"), true);
                    }
                }
            }
        }
    };
    const isLoading = updatingRole || updatingUser || creatingUser || invitingUser || addingRole;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $3YfCm.WidgetLayout), {
        title: !user.id ? text("lblNewUserPage") : text("lblDetailsForPartnerAdmins", {
            firstName: user.firstName,
            lastName: user.lastName
        }),
        "data-testid": "userDetails"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $7315afaaa98651b1$export$a7fed597f4b8afd8), {
        onSubmit: save,
        autoComplete: "off",
        noValidate: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $7315afaaa98651b1$export$816b5d811295e6bc), {
        "data-testid": "firstName"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblFirstNameField"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("input", {
        className: "form-control",
        value: selectedUser.firstName ?? "",
        onChange: (e)=>setSelectedUser({
                ...selectedUser,
                firstName: e.target.value
            }),
        disabled: !isAdmin(),
        "data-testid": "firstName-input"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $7315afaaa98651b1$export$816b5d811295e6bc), {
        "data-testid": "lastName"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblLastNameField"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("input", {
        className: "form-control",
        value: selectedUser.lastName ?? "",
        onChange: (e)=>setSelectedUser({
                ...selectedUser,
                lastName: e.target.value
            }),
        disabled: !isAdmin(),
        "data-testid": "lastName-input"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $7315afaaa98651b1$export$816b5d811295e6bc), {
        "data-testid": "email"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblEmailField"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("input", {
        className: "form-control",
        type: "email",
        name: "email",
        autoComplete: "email",
        value: selectedUser.email ?? "",
        onChange: (e)=>setSelectedUser({
                ...selectedUser,
                email: e.target.value
            }),
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        disabled: user.id || !isAdmin(),
        "data-testid": "email-input"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $7315afaaa98651b1$export$816b5d811295e6bc), {
        "data-testid": "mobile"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblMobileField"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("input", {
        className: "form-control",
        type: "tel",
        value: selectedUser.mobile ?? "",
        onChange: (e)=>setSelectedUser({
                ...selectedUser,
                mobile: e.target.value
            }),
        disabled: !isAdmin(),
        "data-testid": "mobile-input"
    })), !user.id && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $7315afaaa98651b1$export$816b5d811295e6bc), {
        "data-testid": "password"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblNewPasswordField"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("input", {
        className: "form-control",
        type: "password",
        value: selectedUser.password ?? "",
        onChange: (e)=>setSelectedUser({
                ...selectedUser,
                password: e.target.value
            }),
        disabled: !isAdmin(),
        "data-testid": "password-input"
    })), !user.id && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $7315afaaa98651b1$export$816b5d811295e6bc), {
        "data-testid": "password1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblConfirmPasswordField"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("input", {
        className: "form-control",
        type: "password",
        id: "passwordCompare1",
        disabled: !isAdmin(),
        "data-testid": "password1-input"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "align-center",
        "data-testid": "user"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("input", {
        type: "radio",
        name: "role",
        id: "role1",
        value: "User",
        disabled: !isAdmin(),
        "data-testid": "radio-user",
        onChange: (e)=>setSelectedUser({
                ...selectedUser,
                roleInCompany: e.target.value
            }),
        checked: selectedUser.roleInCompany === "User"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", {
        className: "margin-top-6",
        "data-testid": "lbl-radio-userView"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblUserTypeUser"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "align-center",
        "data-testid": "admin"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("input", {
        type: "radio",
        name: "role",
        id: "role2",
        value: "Admin",
        disabled: !isAdmin(),
        checked: selectedUser.roleInCompany === "Admin",
        onChange: (e)=>setSelectedUser({
                ...selectedUser,
                roleInCompany: e.target.value
            }),
        "data-testid": "radio-admin"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", {
        className: "margin-top-6",
        "data-testid": "lbl-radio-admin"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblUserTypeAdmin"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "align-center",
        "data-testid": "adminViewOnly"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("input", {
        type: "radio",
        name: "role",
        id: "role3",
        value: "AdminViewOnly",
        disabled: !isAdmin(),
        "data-testid": "radio-aminView",
        onChange: (e)=>setSelectedUser({
                ...selectedUser,
                roleInCompany: e.target.value
            }),
        checked: selectedUser.roleInCompany === "AdminViewOnly"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", {
        className: "margin-top-6",
        "data-testid": "lbl-radio-adminView"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblUserTypeAdminViewOnly"
    })))), showChangePassword() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $41f551e2ab6e2077$export$2e2bcd8739ae039), {
        openPasswordChange: openPasswordChange,
        setOpenPasswordChange: ()=>closeChangePassword(),
        onChange: (password)=>setSelectedUser({
                ...user,
                passwordChange: {
                    newPassword: password
                }
            })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $9AhwP.ButtonContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
        size: "sm",
        label: text("btnSave"),
        disabled: disableSave(),
        loading: isLoading,
        type: "submit",
        "data-testid": "btnSave"
    }))));
});
var $e183e03c39851310$export$2e2bcd8739ae039 = $e183e03c39851310$var$UserDetails;



var $iFhrk = parcelRequire("iFhrk");

var $aL1Vp = parcelRequire("aL1Vp");
const $7a26b5b12ce6634c$var$Column = (0, $akcQ4.default).div`
    display: flex;
    flex-direction: column;
    width: 50%;

    @media screen and (max-width: 800px) {
        width: 100%;
    }
`;
const $7a26b5b12ce6634c$var$Row = (0, $akcQ4.default).div`
    display: flex;
    flex-direction: row;
    gap: 20px;

    @media screen and (max-width: 800px) {
        flex-direction: column;
    }
`;
const $7a26b5b12ce6634c$export$ecdc3cf9d1cfe143 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).memo(function UserPage() {
    const text = (0, $aL1Vp.default)();
    const dispatch = (0, $4vH3e.useDispatch)();
    const { id: userId } = (0, $84v65.useParams)();
    const companyId = (0, $4vH3e.useSelector)((state)=>state.user.selectedCompanyId);
    const signedInUser = (0, $4vH3e.useSelector)((state)=>state.user);
    /**Fetch data **/ const { data: user } = (0, $fvmYM.useUserGetUserByIdQuery)({
        userId: userId,
        companyId: companyId
    }, {
        skip: !userId,
        refetchOnMountOrArgChange: true
    });
    const { data: nfcTags, refetch: getNfcTags, isLoading: loadingNfcTags } = (0, $fvmYM.useCompanyGetNfcTagsForUserQuery)({
        userId: userId,
        companyId: companyId
    }, {
        skip: !userId,
        refetchOnMountOrArgChange: true
    });
    const { data: registeredChargePoints, isLoading: loadingRegisteredChargePoints } = (0, $fvmYM.useCompanyGetChargePointsForUserQuery)({
        companyId: companyId,
        userId: userId
    }, {
        skip: !userId,
        refetchOnMountOrArgChange: true
    });
    const { data: nfcAccessChargePoints, isLoading: loadingNfcAccessChargePoints } = (0, $fvmYM.useUserGetForUserByNfcAccessWithNfcAccessInfoQuery)({
        companyId: companyId,
        userId: userId
    }, {
        skip: !userId,
        refetchOnMountOrArgChange: true
    });
    const { data: pools, isLoading: loadingPools } = (0, $fvmYM.useUserGetPoolsForSelectedCompanyQuery)({
        userId: userId,
        companyId: companyId
    }, {
        skip: !userId,
        refetchOnMountOrArgChange: true
    });
    const { data: companyPools, isLoading: loadingCompanyPools } = (0, $fvmYM.useCompanyGetPoolsQuery)({
        companyId: companyId
    }, {
        skip: !userId,
        refetchOnMountOrArgChange: true
    });
    /** Mutations **/ const [updateNfcTag] = (0, $fvmYM.useNfcTagUpdateMutation)();
    const [deleteNfcTag] = (0, $fvmYM.useNfcTagDisconnectFromUserMutation)();
    /***************/ (0, $6uMv9.useEffect)(()=>{
        if (user) dispatch((0, $7b817a5f2440b094$export$cb57a0abd67769d3)(user));
    }, [
        dispatch,
        user
    ]);
    const isAdmin = ()=>{
        return (0, $2llRK.default)(signedInUser, companyId, (0, $iFhrk.default).Admin);
    };
    const editNfcTagsGroup = async (tags)=>{
        try {
            for(let i = 0; i < tags.length; i++)await updateNfcTag({
                nfcTag: tags[i]
            }).unwrap();
            await getNfcTags();
            (0, $2460e.notifySuccess)(text("msgRFIDTagsUpdated"));
        } catch (e) {
            (0, $2460e.notifyError)(text("msgNFCTagNotUpdated"));
        }
    };
    const deleteNfcTagFromUser = async (nfcTag)=>{
        try {
            if (nfcTag.id && userId) await deleteNfcTag({
                nfcTagId: nfcTag.id,
                userId: userId
            }).unwrap();
            await getNfcTags();
            (0, $2460e.notifySuccess)(text("msgNFCTagRemoved", {
                id: nfcTag.id
            }));
        } catch (e) {
            (0, $2460e.notifyError)(text("msgRFIDNotRemoved"));
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $52Dbq.PageLayoutContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($7a26b5b12ce6634c$var$Row, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($7a26b5b12ce6634c$var$Column, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $e183e03c39851310$export$2e2bcd8739ae039), null), user && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $20e2a118a44f5a5d$export$a71ecc24683233d6), {
        chargePoints: nfcAccessChargePoints ?? [],
        isAdmin: isAdmin(),
        dataLoadingChargePoints: loadingNfcAccessChargePoints
    }), loadingNfcAccessChargePoints && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $77EIr.WidgetLoadingState), {
        headerButton: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($7a26b5b12ce6634c$var$Column, null, !loadingRegisteredChargePoints && user && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1898cefe68d6ec2b$export$72eeb2e143f5b912), {
        registeredChargePoints: registeredChargePoints ?? [],
        dataLoadingOwnedChargePoints: loadingRegisteredChargePoints
    }), loadingRegisteredChargePoints && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $77EIr.WidgetLoadingState), null), !loadingNfcTags && user && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $b46f809c3d3a32ad$export$dca7950e5ef74285), {
        nfcTags: nfcTags ?? [],
        isAdmin: isAdmin(),
        editNfcTagsGroup: (tags)=>editNfcTagsGroup(tags),
        deleteNfcTagFromUser: (tag)=>deleteNfcTagFromUser(tag)
    }), loadingNfcTags && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $77EIr.WidgetLoadingState), {
        headerButton: true
    }), !loadingPools && user && user.id && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $291a3ae24285c4d8$export$3dcba8e413d97468), {
        pools: pools ?? [],
        isAdmin: isAdmin(),
        dataloadingPools: loadingPools || loadingCompanyPools,
        disableEdit: companyPools?.length === 0,
        userId: user.id
    }), loadingPools && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $77EIr.WidgetLoadingState), {
        headerButton: true
    }))));
});





var $6uMv9 = parcelRequire("6uMv9");

var $iZaUM = parcelRequire("iZaUM");
var $84v65 = parcelRequire("84v65");

var $aIcGc = parcelRequire("aIcGc");

var $4vH3e = parcelRequire("4vH3e");

var $2iotS = parcelRequire("2iotS");

var $eLTOh = parcelRequire("eLTOh");

var $li3ww = parcelRequire("li3ww");

var $lG0u6 = parcelRequire("lG0u6");

var $fvmYM = parcelRequire("fvmYM");

var $6uMv9 = parcelRequire("6uMv9");

var $4vH3e = parcelRequire("4vH3e");

var $iZaUM = parcelRequire("iZaUM");

var $fvmYM = parcelRequire("fvmYM");

var $aL1Vp = parcelRequire("aL1Vp");

var $iXXep = parcelRequire("iXXep");

var $eao00 = parcelRequire("eao00");

var $jyqsN = parcelRequire("jyqsN");

var $6nGY6 = parcelRequire("6nGY6");
const $89aefb13e42ed12f$export$a4c3015f5b9342d9 = ()=>{
    const text = (0, $aL1Vp.default)();
    const navigate = (0, $iZaUM.useNavigate)();
    const dispatch = (0, $4vH3e.useDispatch)();
    const { data: organisations, isLoading: isLoading } = (0, $fvmYM.useCompanyGetAdministratedCompaniesQuery)();
    const organisationOptions = organisations?.map((organisation)=>({
            label: organisation?.name,
            value: organisation?.id
        }));
    const signedInUser = (0, $4vH3e.useSelector)((state)=>state.user);
    const handleChangeOrganisation = (companyId)=>{
        if (!signedInUser || !signedInUser.selectedCompanyId) {
            navigate("/login", {
                replace: true
            });
            return;
        }
        const userAfterSelectCompany = {
            ...signedInUser,
            selectedCompanyId: companyId ?? ""
        };
        (0, $eao00.default)(userAfterSelectCompany);
        dispatch((0, $jyqsN.setUser)(userAfterSelectCompany));
        (0, $6nGY6.triggerAuthChange)();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iXXep.Dropdown), {
        className: "w-10rem md:w-auto",
        id: "organisation-select",
        options: organisationOptions,
        value: signedInUser?.selectedCompanyId,
        onChange: (event)=>handleChangeOrganisation(event.value),
        loading: isLoading,
        filter: true,
        virtualScrollerOptions: {
            itemSize: 38
        },
        placeholder: text("lblSelectOrganisation"),
        showClear: false
    });
};



var $aL1Vp = parcelRequire("aL1Vp");

var $1xw2Y = parcelRequire("1xw2Y");

var $eQupZ = parcelRequire("eQupZ");

var $3jZfA = parcelRequire("3jZfA");

var $9bidY = parcelRequire("9bidY");
const $d34a5604f01cb559$export$1a35d6ac86f34b1b = ()=>{
    const { transferKey: transferKey } = (0, $84v65.useParams)();
    const navigate = (0, $iZaUM.useNavigate)();
    const text = (0, $aL1Vp.default)();
    const toast = (0, $3jZfA.useToast)();
    const [confirmTransfer, setConfirmTransfer] = (0, $6uMv9.useState)(false);
    const handleConfirmChange = (e)=>{
        setConfirmTransfer(Boolean(e.checked));
    };
    const { selectedCompanyId: selectedCompanyId } = (0, $4vH3e.useSelector)((state)=>state.user);
    const { data: companyInfo } = (0, $fvmYM.useCompanyGetCompanyByIdQuery)({
        companyId: selectedCompanyId
    }, {
        skip: !selectedCompanyId
    });
    const { data: partner, error: partnerError } = (0, $fvmYM.useCompanyTransferGetPartnerQuery)({
        transferKey: transferKey ?? "",
        companyId: selectedCompanyId
    }, {
        skip: !transferKey || !selectedCompanyId
    });
    const [requestTransfer] = (0, $fvmYM.useCompanyTransferRequestTransferMutation)();
    const renderAlreadyBelongsToPartnerContent = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $eQupZ.LandingMessage), {
            type: (0, $eQupZ.LandingMessageType).SUCCESS,
            title: text("lblTransferToANewPartner"),
            linkText: text("btnGoToDashboard"),
            onClick: ()=>{
                navigate("/dashboard", {
                    replace: true
                });
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
            code: "msgTransferOrganisationAlreadyBelongsToPartner",
            values: {
                partnerName: partner?.name
            }
        })));
    };
    const renderInvalidOrExpiredContent = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $eQupZ.LandingMessage), {
            title: text("lblTransferLinkIsInvalid"),
            linkText: text("btnGoToDashboard"),
            onClick: ()=>{
                navigate("/dashboard", {
                    replace: true
                });
            },
            type: (0, $eQupZ.LandingMessageType).ERROR
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
            "data-testid": "message"
        }, text("msgTransferInvalidLink")));
    };
    const renderDefaultContent = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $eQupZ.LandingMessage), {
            title: text("lblTransferToANewPartner")
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
            code: "msgDoYouWantToChangePartner",
            values: {
                fromPartner: companyInfo?.partnerName,
                toPartner: partner?.name,
                organisation: companyInfo?.name
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("p", null, text("msgAfterTheTransferInfo")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $eLTOh.Message), {
            severity: "error",
            className: "w-full mb-3",
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("p", {
                className: "m-0 p-0 text-left"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
                code: "msgTransferConfirmationWarning",
                values: {
                    currentPartner: companyInfo?.partnerName,
                    organisationName: companyInfo?.name
                }
            }))
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
            className: "flex align-items-center mb-4"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2iotS.Checkbox), {
            inputId: "confirmTransfer",
            checked: confirmTransfer,
            onChange: handleConfirmChange,
            className: "mr-2"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("label", {
            htmlFor: "confirmTransfer",
            className: "cursor-pointer mb-0"
        }, text("msgTransferConfirmation"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
            className: "flex justify-content-between gap-2 mt-4"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $aIcGc.Button), {
            outlined: true,
            label: text("btnCancel"),
            "data-testid": "cancel-btn",
            onClick: ()=>navigate("/dashboard", {
                    replace: true
                })
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $aIcGc.Button), {
            label: text("btnApprove"),
            "data-testid": "approve-btn",
            disabled: !confirmTransfer,
            onClick: ()=>{
                if (transferKey && selectedCompanyId) requestTransfer({
                    transferKey: transferKey,
                    companyId: selectedCompanyId
                }).unwrap().then(()=>{
                    navigate("/change-operator-success", {
                        replace: true
                    });
                }).catch((error)=>{
                    if ((0, $9bidY.isFetchBaseQueryError)(error)) {
                        if (error.status === 403) toast.notifyError(text("msgTransferInsufficientPermissions"));
                        else toast.notifyError(text("lblSomethingWentWrong"));
                    }
                });
            }
        })));
    };
    const renderContent = ()=>{
        if (partnerError) return renderInvalidOrExpiredContent();
        if (partner && companyInfo) {
            if (partner?.id === companyInfo?.partnerId) return renderAlreadyBelongsToPartnerContent();
            return renderDefaultContent();
        }
        return null;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $li3ww.LandingPageLayout), {
        background: (0, $lG0u6.theme).whiteBackground,
        hideLanguageSelect: true,
        headerContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $89aefb13e42ed12f$export$a4c3015f5b9342d9), null)
    }, renderContent());
};



var $6uMv9 = parcelRequire("6uMv9");

var $iZaUM = parcelRequire("iZaUM");

var $aL1Vp = parcelRequire("aL1Vp");

var $li3ww = parcelRequire("li3ww");

var $eQupZ = parcelRequire("eQupZ");

var $lG0u6 = parcelRequire("lG0u6");

var $6uMv9 = parcelRequire("6uMv9");

var $174na = parcelRequire("174na");
function $721bd8e762e7895f$export$8aed1aa80404ed23({ className: className, style: style, width: width = 151, height: height = 150, color: color = "#81E18B", ["data-testid"]: dataTestid = "mark-email-icon" }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("svg", {
        width: "151",
        height: "150",
        viewBox: "0 0 151 150",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("mask", {
        id: "mask0_4816_2011",
        // style="mask-type:alpha"
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: width,
        height: height,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($174na)))(className),
        style: style,
        "data-testid": dataTestid
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("rect", {
        x: "0.5",
        width: "150",
        height: "150",
        fill: "#D9D9D9"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("g", {
        mask: "url(#mask0_4816_2011)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("path", {
        d: "M96.4375 131.562L75.5 110.625L78.625 107.5L96.4375 125.312L132.062 89.6875L135.188 92.8125L96.4375 131.562ZM75.5 68.75L123 37.5H28L75.5 68.75ZM75.5 74.0625L25.5 40.9375V107.5C25.5 108.958 25.9688 110.156 26.9062 111.094C27.8438 112.031 29.0417 112.5 30.5 112.5H59.7188L64.0938 116.875H30.5C27.7917 116.875 25.5521 115.99 23.7812 114.219C22.0104 112.448 21.125 110.208 21.125 107.5V42.5C21.125 39.7917 22.0104 37.5521 23.7812 35.7812C25.5521 34.0104 27.7917 33.125 30.5 33.125H120.5C123.208 33.125 125.448 34.0104 127.219 35.7812C128.99 37.5521 129.875 39.7917 129.875 42.5V74.375L125.5 78.75V40.9375L75.5 74.0625Z",
        fill: color
    })));
}




const $b0bb38ad1b756469$export$d99df8dc0cf8373 = ()=>{
    const text = (0, $aL1Vp.default)();
    const navigate = (0, $iZaUM.useNavigate)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $li3ww.LandingPageLayout), {
        background: (0, $lG0u6.theme).whiteBackground,
        hideLanguageSelect: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $eQupZ.LandingMessage), {
        title: text("lblTransferRequestSent"),
        linkText: text("btnGoToDashboard"),
        onClick: ()=>{
            navigate("/dashboard", {
                replace: true
            });
        },
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $721bd8e762e7895f$export$8aed1aa80404ed23), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        "data-testid": "message"
    }, text("msgTransferRequestSent"))));
};




const $900031b0805613a7$var$RequireAuth = ({ children: children, isHeaderShown: isHeaderShown = true })=>{
    const location = (0, $iZaUM.useLocation)();
    const token = (0, $4vH3e.useSelector)((state)=>state.token);
    const allowAccess = (0, $4vH3e.useSelector)((state)=>state.user.isSuperAdmin || state.user.roles.some((r)=>r.claim === (0, $iFhrk.default).Admin || r.claim === (0, $iFhrk.default).AdminViewOnly));
    const companyId = (0, $4vH3e.useSelector)((state)=>state.user.selectedCompanyId);
    if (!token || !allowAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Navigate), {
        to: "/login",
        state: {
            from: location.pathname
        },
        replace: true
    });
    if (!companyId && location.pathname !== "/select-organisation") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Navigate), {
        to: "/select-organisation",
        state: {
            from: location.pathname
        },
        replace: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", null, isHeaderShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $9459cedc4eb36344$export$2e2bcd8739ae039), {
        className: "page-layout-header pt-5 pb-6 xl:pt-4 xl:pb-4"
    }), children);
};
const $900031b0805613a7$var$App = ()=>{
    const isFortum = (0, $klmJ0.currentCompany) === (0, $klmJ0.Company).FORTUM;
    const token = (0, $4vH3e.useSelector)((state)=>state.token);
    const location = (0, $iZaUM.useLocation)();
    (0, $6uMv9.useLayoutEffect)(()=>{
        // Scroll to the top of the page when the route changes
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "instant"
        });
    }, [
        location.pathname
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $7Al71.HeadProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $7Al71.Title), null, isFortum ? "Fortum Admin" : "Charge Amps Admin"), isFortum && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $7Al71.Link), {
        rel: "stylesheet",
        href: "/common/content/customers/fortum/fortum.css"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $7Al71.Link), {
        rel: "shortcut icon",
        href: isFortum ? "/common/content/customers/fortum/images/fortum_favicon.ico" : "/common/content/images/favicon-16.png"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $7Al71.Link), {
        rel: "apple-touch-icon",
        href: isFortum ? "/common/content/customers/fortum/images/fortum_logo_apple_touch_icon.png" : "/common/content/images/logo_white_retina.png"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Routes), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Route), {
        path: "/*",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Navigate), {
            to: token ? "/dashboard" : "/login"
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Route), {
        path: "login",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $73srW.SignInPage), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Route), {
        path: "reset-password",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $7Xmh2.PasswordResetPage), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Route), {
        path: "acceptInvitation",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $18a00e9f2cf48270$export$49b43be1058c84eb), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Route), {
        path: "reset-password-request",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $ieBDX.ResetPasswordRequestPage), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Route), {
        path: "reset-password-request-success",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $d1vMk.ResetPasswordRequestSuccessPage), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Route), {
        path: "reset-password-request-error",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $bMIKZ.ResetPasswordRequestErrorPage), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Route), {
        path: "select-organisation",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($900031b0805613a7$var$RequireAuth, {
            isHeaderShown: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f8186f2222fd08ed$export$d89e43e3db240a63), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Route), {
        path: "change-operator/:transferKey",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($900031b0805613a7$var$RequireAuth, {
            isHeaderShown: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $d34a5604f01cb559$export$1a35d6ac86f34b1b), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Route), {
        path: "change-operator-success",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($900031b0805613a7$var$RequireAuth, {
            isHeaderShown: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $b0bb38ad1b756469$export$d99df8dc0cf8373), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Route), {
        path: "dashboard",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($900031b0805613a7$var$RequireAuth, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $83748f3a781d02af$export$fedd53519a0e2bce), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Route), {
        path: "pools",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($900031b0805613a7$var$RequireAuth, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $fc8cf465af1d1012$export$4c210577356eef88), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Route), {
        path: "pool/:poolId",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($900031b0805613a7$var$RequireAuth, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $a6f1b77cf073a9bb$export$72fb5ffeaac1b378), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Route), {
        path: "measurementDevices",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($900031b0805613a7$var$RequireAuth, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $669e5c4117a99b3c$export$8de4554fe05e44f8), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Route), {
        path: "measurementDevice/:deviceId",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($900031b0805613a7$var$RequireAuth, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $4yml8.MeasurementDevicePage), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Route), {
        path: "loadbalancer",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($900031b0805613a7$var$RequireAuth, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8XNZy.LoadbalancerPage), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Route), {
        path: "loadbalancer/:id",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($900031b0805613a7$var$RequireAuth, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2vwem.LoadBalancerDetailsWidgetPage), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Route), {
        path: "nfcTags",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($900031b0805613a7$var$RequireAuth, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1iE9F.RFIDTagsPage), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Route), {
        path: "users",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($900031b0805613a7$var$RequireAuth, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $df1fee63ce6dbb8d$export$107317390f5aa598), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Route), {
        path: "user",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($900031b0805613a7$var$RequireAuth, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $7a26b5b12ce6634c$export$ecdc3cf9d1cfe143), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Route), {
        path: "user/:id",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($900031b0805613a7$var$RequireAuth, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $7a26b5b12ce6634c$export$ecdc3cf9d1cfe143), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Route), {
        path: "user/:id/userPools",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($900031b0805613a7$var$RequireAuth, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $d985915eb438d417$export$51ad302672431b01), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Route), {
        path: "user/:id/userChargePoints",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($900031b0805613a7$var$RequireAuth, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $721a58a909e6a690$export$11c799359c81f5d8), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Route), {
        path: "user/:id/userNfcTags",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($900031b0805613a7$var$RequireAuth, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8c535813f07c5508$export$39bb14b1a5fcc6b8), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Route), {
        path: "chargepoints",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($900031b0805613a7$var$RequireAuth, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $5926fd6dea5d15b9$export$99edf21a326d7114), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Route), {
        path: "chargepoints/:chargePointId",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($900031b0805613a7$var$RequireAuth, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $6Sp0E.ChargePointDetailsPage), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Route), {
        path: "reports",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($900031b0805613a7$var$RequireAuth, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $lVzQC.ReportsPage), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $84v65.Route), {
        path: "settings",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($900031b0805613a7$var$RequireAuth, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $52f08e8cd1183bb7$export$8f6dcfe950367406), null))
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $ckDUJ.default), null));
};
var $900031b0805613a7$export$2e2bcd8739ae039 = $900031b0805613a7$var$App;



var $y9267 = parcelRequire("y9267");
var $5P7fB = parcelRequire("5P7fB");

var $51LwC = parcelRequire("51LwC");

var $4JKIh = parcelRequire("4JKIh");

var $eynVN = parcelRequire("eynVN");

var $hatLe = parcelRequire("hatLe");

var $dNgoi = parcelRequire("dNgoi");

var $6n2U1 = parcelRequire("6n2U1");

var $jyqsN = parcelRequire("jyqsN");

var $32r9b = parcelRequire("32r9b");

var $5P7fB = parcelRequire("5P7fB");
const $4e95d149e0ff4e77$var$initialState = {
    value: 0
};
const $4e95d149e0ff4e77$export$8dea1a5d9f48fb86 = (0, $5P7fB.createSlice)({
    name: "chargepoints",
    initialState: $4e95d149e0ff4e77$var$initialState,
    reducers: {
        increment: (state)=>{
            state.value += 1;
        },
        decrement: (state)=>{
            state.value -= 1;
        },
        incrementByAmount: (state, action)=>{
            state.value += action.payload;
        }
    }
});
const { increment: $4e95d149e0ff4e77$export$a2647aa13413c947, decrement: $4e95d149e0ff4e77$export$8f85cc9753f280aa, incrementByAmount: $4e95d149e0ff4e77$export$baefabcc3c150367 } = $4e95d149e0ff4e77$export$8dea1a5d9f48fb86.actions;
var $4e95d149e0ff4e77$export$2e2bcd8739ae039 = $4e95d149e0ff4e77$export$8dea1a5d9f48fb86.reducer;



const $7a45b07f7ac66f84$var$createRootReducers = ()=>{
    const rootReducerFn = (0, $y9267.combineReducers)({
        chargePoints: (0, $4e95d149e0ff4e77$export$2e2bcd8739ae039),
        company: (0, $hatLe.default),
        user: (0, $jyqsN.default),
        token: (0, $dNgoi.default),
        selectedUser: (0, $7b817a5f2440b094$export$2e2bcd8739ae039),
        [(0, $32r9b.chargePointApi).reducerPath]: (0, $32r9b.chargePointApi).reducer,
        [(0, $6n2U1.enhancedApi).reducerPath]: (0, $6n2U1.enhancedApi).reducer
    });
    return (state, action)=>{
        return rootReducerFn((0, $jyqsN.reset) && action.type === (0, $jyqsN.reset).type ? undefined : state, action);
    };
};
const $7a45b07f7ac66f84$var$persistConfig = {
    key: "root",
    version: 1,
    storage: $eynVN.default,
    whitelist: [
        "user",
        "token"
    ]
};
const $7a45b07f7ac66f84$var$persistedReducer = (0, $4JKIh.persistReducer)($7a45b07f7ac66f84$var$persistConfig, $7a45b07f7ac66f84$var$createRootReducers());
const $7a45b07f7ac66f84$export$6f57813fe9f31bf9 = (0, $5P7fB.configureStore)({
    reducer: $7a45b07f7ac66f84$var$persistedReducer,
    devTools: false,
    middleware: (getDefaultMiddleware)=>getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [
                    (0, $4JKIh.FLUSH),
                    (0, $4JKIh.REHYDRATE),
                    (0, $4JKIh.PAUSE),
                    (0, $4JKIh.PERSIST),
                    (0, $4JKIh.PURGE),
                    (0, $4JKIh.REGISTER)
                ]
            }
        }).concat([
            (0, $32r9b.chargePointApi).middleware,
            (0, $6n2U1.enhancedApi).middleware
        ])
});
const $7a45b07f7ac66f84$export$1b3de3898efde2ba = (preloadedState)=>{
    return (0, $5P7fB.configureStore)({
        reducer: $7a45b07f7ac66f84$var$createRootReducers(),
        devTools: false,
        middleware: (getDefaultMiddleware)=>getDefaultMiddleware().concat([
                (0, $32r9b.chargePointApi).middleware,
                (0, $6n2U1.enhancedApi).middleware
            ]),
        preloadedState: preloadedState
    });
};
const $7a45b07f7ac66f84$export$7b682ac9934ca3e4 = (0, $4JKIh.persistStore)($7a45b07f7ac66f84$export$6f57813fe9f31bf9);
(0, $51LwC.setupListeners)($7a45b07f7ac66f84$export$6f57813fe9f31bf9.dispatch);


const $807736619e57f01b$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($fXJGT))).createRoot(document.getElementById("root"));
$807736619e57f01b$var$root.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dcOIZ.ThemeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $6uMv9.Suspense), {
    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", null)
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iAZE5.LocalizationProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $4vH3e.Provider), {
    store: (0, $7a45b07f7ac66f84$export$6f57813fe9f31bf9)
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $edR9j.PersistGate), {
    loading: null,
    persistor: (0, $7a45b07f7ac66f84$export$7b682ac9934ca3e4)
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cFTyZ.PrimeReactProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $3jZfA.ToastProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iZaUM.BrowserRouter), {
    basename: "admin"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $900031b0805613a7$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iQS7O.ConfirmDialog), {
    style: {
        width: "40vw"
    },
    breakpoints: {
        "1100px": "75vw",
        "960px": "100vw"
    }
}))))))))));


//# sourceMappingURL=index.47e357f9.js.map
